import React, { useState, useEffect, useRef } from 'react';
import { IconButton, Button } from '@mui/material';
import { AddBox } from '@mui/icons-material';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import { API, graphqlOperation } from 'aws-amplify';
import { getItemmaster, getItemmasterAmountDetails, listItemMasterSearch } from '../../../graphql';
import AddNewItemModal from '../Modals/AddNewItemModal';
import AddHSNModal from '../Modals/AddHSNModal';
import { showWarningSnackbar } from '../../../components/snackBar/snakbar';
import { makeStyles } from '@mui/styles';
import { useSelector } from 'react-redux';
import ToolTipComponent from '../Components/ToolTipComponent';
import { useAccountDetails } from '../Components/AccountDetailsProvider';
import { useListAccountMasterv2Query } from '../../../redux/apis/accountMaster.api';
import useInfiniteScroll from '../Components/UseInfiniteScroll';
import { useTaxabilityOptions } from '../Components/UseTaxabilityOptions';
import UseHSNMaster from '../Components/UseHSNMaster';
import moment from 'moment';
import { useListPriceTypesQuery } from '../../../redux/apis/pricetype.api';
import ItemRowMemo from './ItemRowMemo';
import { useHandleTaxabilityChange } from '../Components/useHandleTaxabilityChange';

const useStyles = makeStyles((theme) => ({
  autocomplete: {
    '& .MuiAutocomplete-popper': {
      minWidth: 1000, // Adjust the width as needed
    },
  },
}));

function NewItemTable({
  itemWiseAccordan,
  setItemWiseAccordan,
  setInitItemTableDta,
  setItems,
  items,
  setIsFocusItem,
  setIsFocusNonItem,
  data,
  rowIndex,
  setRowIndex,
  companyState,
  setItemID,
  itemID,
  setItemType,
  itemType,
  Type,
  invoiceEntry,
  units,
  originalInvoiceNos,
  unitsObj,
  partyType,
  registrationType,
  companyData,
  setBackdropOpen,
  viewMode,
  tabelCellClass,
  setIsFocusItemRow,
  setItemValid,
  itemValid,
  setNonItemValid,
  handleResetScroll,
  setAccNames,
  setTableErrArr,
  newItemObj,
  setDeleteEntriesModal,
  itemCodes,
  setItemCodes,
  itemNames,
  setItemNames,
}) {
  const classes = useStyles();
  let getCompany = useSelector((state) => state?.companyReducer?.companyDetails);

  let EInvoiceFlag = getCompany?.relatedcompanydetailsnew?.[0]?.einvoiceflag;
  let companyType = getCompany?.relatedcompanydetailsnew?.[0]?.registrationtype;
  const accountDetails = useAccountDetails();
  const { data: priceList, isLoading: isGroupLoading, isError } = useListPriceTypesQuery();
  //LEDX-4724---->>>
  const {
    taxabilityOptions,
    compositeTaxability,
    taxabilityOutsideIndia,
    compositeTaxabilityForCustomer,
    unrSupplierTaxability,
    customerTaxabilityOptions,
  } = useTaxabilityOptions();
  const handleTaxabilityChange = useHandleTaxabilityChange({
    Type,
  });
  //LEDX-4724---->>>

  const itemWiseHeader = [
    {
      id: 'S.No',
      label: 'S.No',
      width: 20,
      align: 'left',
      currency: '',
      required: '',
    },
    {
      id: 'Item Code',
      label: 'Item Code',
      width: 80,
      align: 'left',
      currency: '',
      required: <span style={{ color: '#e55353', paddingLeft: '2px' }}>*</span>,
    },
    {
      id: 'Item Name',
      label: 'Item Name',
      width: 120,
      align: 'left',
      currency: '',
      required: <span style={{ color: '#e55353', paddingLeft: '2px' }}>*</span>,
    },
    {
      id: 'Price Type',
      label: 'Price Type',
      width: 80,
      align: 'left',
      currency: '',
      required: '',
    },
    {
      id: 'Reason',
      label: 'Reason',
      width: 140,
      align: 'left',
      currency: '',
      required: '',
    },

    {
      id: 'GST',
      label:
        (partyType === 'CUSTOMER' || Type === 'Pos') && companyType === 3 ? (
          <>
            Comp.
            <br />
            GST (%)
          </>
        ) : (
          'GST (%)'
        ),
      width: 40,
      align: 'left',
      currency: '',
      required: <span style={{ color: '#e55353', paddingLeft: '2px' }}>*</span>,
    },
    {
      id: 'HSN/SAC',
      label: 'HSN/SAC',
      width: 120,
      align: 'left',
      currency: '',
      required: '',
    },

    {
      id: 'Qty',
      label: 'Qty',
      width: 100,
      align: 'left',
      currency: '',
      required: <span style={{ color: '#e55353', paddingLeft: '2px' }}>*</span>,
    },
    {
      id: 'Units',
      label: 'Units',
      width: 120,
      align: 'left',
      currency: '',
      required: <span style={{ color: '#e55353', paddingLeft: '2px' }}>*</span>,
    },
    {
      id: 'Rate',
      label: 'Rate',
      width: 120,
      align: 'right',
      currency: data?.currency?.sign,
      required: <span style={{ color: '#e55353', paddingLeft: '2px' }}>*</span>,
    },
    {
      id: 'Amount',
      label: 'Amount',
      width: 120,
      align: 'right',
      currency: data?.currency?.sign,
      required: '',
    },
    {
      id: 'Discount',
      label: 'Discount',
      width: 120,
      align: 'right',
      currency: data?.currency?.sign,
      required: '',
    },
    {
      id: 'Taxable Amt',
      label: 'Taxable Amt',
      width: 120,
      align: 'right',
      currency: data?.currency?.sign,
      required: '',
    },
    {
      id: 'GST Amt',
      label: 'GST Amt',
      width: 120,
      align: 'right',
      currency: data?.currency?.sign,
      required: '',
    },
    {
      id: 'Cess',
      label: 'Cess',
      width: 80,
      align: 'right',
      currency: data?.currency?.sign,
      required: '',
    },
    {
      id: 'Net Amt',
      label: 'Net Amt',
      width: 120,
      align: 'right',
      currency: data?.currency?.sign,
      required: '',
    },
    {
      id: 'action',
      label: 'Action',
      width: 40,
      align: 'center',
      currency: '',
      required: '',
    },
  ];
  const itemWiseHeaderWithoutCess = [
    {
      id: 'S.No',
      label: 'S.No',
      width: 20,
      align: 'left',
      currency: '',
      required: '',
    },
    {
      id: 'Item Code',
      label: 'Item Code',
      width: 80,
      align: 'left',
      currency: '',
      required: <span style={{ color: '#e55353', paddingLeft: '2px' }}>*</span>,
    },

    {
      id: 'Item Name',
      label: 'Item Name',
      width: 120,
      align: 'left',
      currency: '',
      required: <span style={{ color: '#e55353', paddingLeft: '2px' }}>*</span>,
    },
    {
      id: 'Price Type',
      label: 'Price Type',
      width: 80,
      align: 'left',
      currency: '',
      required: '',
    },
    {
      id: 'Reason',
      label: 'Reason',
      width: 140,
      align: 'left',
      currency: '',
      required: '',
    },

    {
      id: 'GST',
      label:
        (partyType === 'CUSTOMER' || Type === 'Pos') && companyType === 3 ? (
          <>
            Comp.
            <br />
            GST (%)
          </>
        ) : (
          'GST (%)'
        ),
      width: 40,
      align: 'left',
      currency: '',
      required: <span style={{ color: '#e55353', paddingLeft: '2px' }}>*</span>,
    },
    {
      id: 'HSN/SAC',
      label: 'HSN/SAC',
      width: 120,
      align: 'left',
      currency: '',
      required: '',
    },

    {
      id: 'Qty',
      label: 'Qty',
      width: 140,
      align: 'left',
      currency: '',
      required: <span style={{ color: '#e55353', paddingLeft: '2px' }}>*</span>,
    },
    {
      id: 'Units',
      label: 'Units',
      width: 120,
      align: 'left',
      currency: '',
      required: <span style={{ color: '#e55353', paddingLeft: '2px' }}>*</span>,
    },
    {
      id: 'Rate',
      label: 'Rate',
      width: 140,
      align: 'right',
      currency: data?.currency?.sign,
      required: <span style={{ color: '#e55353', paddingLeft: '2px' }}>*</span>,
    },
    {
      id: 'Amount',
      label: 'Amount',
      width: 120,
      align: 'right',
      currency: data?.currency?.sign,
      required: '',
    },
    {
      id: 'Discount',
      label: 'Discount',
      width: 140,
      align: 'right',
      currency: data?.currency?.sign,
      required: '',
    },
    {
      id: 'Taxable Amt',
      label: 'Taxable Amt',
      width: 120,
      align: 'right',
      currency: data?.currency?.sign,
      required: '',
    },
    {
      id: 'GST Amt',
      label: 'GST Amt',
      width: 120,
      align: 'right',
      currency: data?.currency?.sign,
      required: '',
    },
    {
      id: 'Net Amt',
      label: 'Net Amt',
      width: 120,
      align: 'right',
      currency: data?.currency?.sign,
      required: '',
    },
    {
      id: 'action',
      label: 'Action',
      width: 40,
      align: 'center',
      currency: '',
      required: '',
    },
  ];

  const compositetaxTypeitemWiseHeader = [
    {
      id: 'S.No',
      label: 'S.No',
      width: 20,
      align: 'left',
      currency: '',
      required: '',
    },
    {
      id: 'Item Code',
      label: 'Item Code',
      width: 80,
      align: 'left',
      currency: '',
      required: <span style={{ color: '#e55353', paddingLeft: '2px' }}>*</span>,
    },
    {
      id: 'Item Name',
      label: 'Item Name',
      width: 120,
      align: 'left',
      currency: '',
      required: <span style={{ color: '#e55353', paddingLeft: '2px' }}>*</span>,
    },
    {
      id: 'Price Type',
      label: 'Price Type',
      width: 80,
      align: 'left',
      currency: '',
      required: '',
    },
    {
      id: 'Reason',
      label: 'Reason',
      width: 140,
      align: 'left',
      currency: '',
      required: '',
    },
    {
      id: 'HSN/SAC',
      label: 'HSN/SAC',
      width: 120,
      align: 'left',
      currency: '',
      required: '',
    },

    {
      id: 'Qty',
      label: 'Qty',
      width: 140,
      align: 'left',
      currency: '',
      required: <span style={{ color: '#e55353', paddingLeft: '2px' }}>*</span>,
    },
    {
      id: 'Units',
      label: 'Units',
      width: 120,
      align: 'right',
      currency: data?.currency?.sign,
      required: <span style={{ color: '#e55353', paddingLeft: '2px' }}>*</span>,
    },
    {
      id: 'Rate',
      label: 'Rate',
      width: 140,
      align: 'right',
      currency: data?.currency?.sign,
      required: <span style={{ color: '#e55353', paddingLeft: '2px' }}>*</span>,
    },
    {
      id: 'Amount',
      label: 'Amount',
      width: 120,
      align: 'right',
      currency: data?.currency?.sign,
      required: '',
    },
    {
      id: 'Discount',
      label: 'Discount',
      width: 140,
      align: 'right',
      currency: data?.currency?.sign,
      required: '',
    },

    {
      id: 'Net Amt',
      label: 'Net Amt',
      width: 120,
      align: 'right',
      currency: data?.currency?.sign,
      required: '',
    },
    {
      id: 'action',
      label: 'Action',
      width: 40,
      align: 'center',
      currency: '',
      required: '',
    },
  ];
  const taxTypeitemWiseHeader = [
    {
      id: 'S.No',
      label: 'S.No',
      width: 20,
      align: 'left',
      currency: '',
      required: '',
    },
    {
      id: 'Item Code',
      label: 'Item Code',
      width: 80,
      align: 'left',
      currency: '',
      required: <span style={{ color: '#e55353', paddingLeft: '2px' }}>*</span>,
    },
    {
      id: 'Item Name',
      label: 'Item Name',
      width: 120,
      align: 'left',
      currency: '',
      required: <span style={{ color: '#e55353', paddingLeft: '2px' }}>*</span>,
    },
    {
      id: 'Price Type',
      label: 'Price Type',
      width: 80,
      align: 'left',
      currency: '',
      required: '',
    },
    {
      id: 'Reason',
      label: 'Reason',
      width: 140,
      align: 'left',
      currency: '',
      required: '',
    },
    {
      id: 'HSN/SAC',
      label: 'HSN/SAC',
      width: 120,
      align: 'left',
      currency: '',
      required: '',
    },

    {
      id: 'Qty',
      label: 'Qty',
      width: 140,
      align: 'left',
      currency: '',
      required: <span style={{ color: '#e55353', paddingLeft: '2px' }}>*</span>,
    },
    {
      id: 'Units',
      label: 'Units',
      width: 120,
      align: 'right',
      currency: data?.currency?.sign,
      required: <span style={{ color: '#e55353', paddingLeft: '2px' }}>*</span>,
    },
    {
      id: 'Rate',
      label: 'Rate',
      width: 140,
      align: 'right',
      currency: data?.currency?.sign,
      required: <span style={{ color: '#e55353', paddingLeft: '2px' }}>*</span>,
    },
    {
      id: 'Amount',
      label: 'Amount',
      width: 120,
      align: 'right',
      currency: data?.currency?.sign,
      required: '',
    },
    {
      id: 'Discount',
      label: 'Discount',
      width: 140,
      align: 'right',
      currency: data?.currency?.sign,
      required: '',
    },
    {
      id: 'Taxable Amt',
      label: 'Taxable Amt',
      width: 120,
      align: 'right',
      currency: data?.currency?.sign,
      required: '',
    },
    {
      id: 'Net Amt',
      label: 'Net Amt',
      width: 120,
      align: 'right',
      currency: data?.currency?.sign,
      required: '',
    },
    {
      id: 'action',
      label: 'Action',
      width: 40,
      align: 'center',
      currency: '',
      required: '',
    },
  ];
  const unRegistereditemWiseHeader = [
    {
      id: 'S.No',
      label: 'S.No',
      width: 20,
      align: 'left',
      currency: '',
      required: '',
    },
    {
      id: 'Item Code',
      label: 'Item Code',
      width: 80,
      align: 'left',
      currency: '',
      required: <span style={{ color: '#e55353', paddingLeft: '2px' }}>*</span>,
    },
    {
      id: 'Item Name',
      label: 'Item Name',
      width: 120,
      align: 'left',
      currency: '',
      required: <span style={{ color: '#e55353', paddingLeft: '2px' }}>*</span>,
    },
    {
      id: 'Price Type',
      label: 'Price Type',
      width: 80,
      align: 'left',
      currency: '',
      required: '',
    },
    {
      id: 'Reason',
      label: 'Reason',
      width: 140,
      align: 'left',
      currency: '',
      required: '',
    },

    {
      id: 'Qty',
      label: 'Qty',
      width: 140,
      align: 'left',
      currency: '',
      required: <span style={{ color: '#e55353', paddingLeft: '2px' }}>*</span>,
    },
    {
      id: 'Units',
      label: 'Units',
      width: 120,
      align: 'right',
      currency: data?.currency?.sign,
      required: <span style={{ color: '#e55353', paddingLeft: '2px' }}>*</span>,
    },
    {
      id: 'Rate',
      label: 'Rate',
      width: 140,
      align: 'right',
      currency: data?.currency?.sign,
      required: <span style={{ color: '#e55353', paddingLeft: '2px' }}>*</span>,
    },
    {
      id: 'Amount',
      label: 'Amount',
      width: 120,
      align: 'right',
      currency: data?.currency?.sign,
      required: '',
    },
    {
      id: 'Discount',
      label: 'Discount',
      width: 140,
      align: 'right',
      currency: data?.currency?.sign,
      required: '',
    },
    {
      id: 'Net Amt',
      label: 'Net Amt',
      width: 120,
      align: 'right',
      currency: data?.currency?.sign,
      required: '',
    },
    {
      id: 'action',
      label: 'Action',
      width: 40,
      align: 'center',
      currency: '',
      required: '',
    },
  ];
  const compositeItemWiseHeader = [
    {
      id: 'S.No',
      label: 'S.No',
      width: 20,
      align: 'left',
      currency: '',
      required: '',
    },
    {
      id: 'Item Code',
      label: 'Item Code',
      width: 80,
      align: 'left',
      currency: '',
      required: <span style={{ color: '#e55353', paddingLeft: '2px' }}>*</span>,
    },
    {
      id: 'Item Name',
      label: 'Item Name',
      width: 120,
      align: 'left',
      currency: '',
      required: <span style={{ color: '#e55353', paddingLeft: '2px' }}>*</span>,
    },
    {
      id: 'Price Type',
      label: 'Price Type',
      width: 80,
      align: 'left',
      currency: '',
      required: '',
    },
    {
      id: 'Reason',
      label: 'Reason',
      width: 140,
      align: 'left',
      currency: '',
      required: '',
    },
    // {
    //   id: "Taxability",
    //   label: "Taxability",
    //   width: 120,
    //   align: "left",
    //   currency: "",
    //   required: <span style={{ color: "#e55353", paddingLeft: "2px" }}>*</span>,
    // },
    {
      id: 'GST',
      label:
        (partyType === 'CUSTOMER' || Type === 'Pos') && companyType === 3 ? (
          <>
            Comp.
            <br />
            GST (%)
          </>
        ) : (
          'GST (%)'
        ),
      width: 40,
      align: 'left',
      currency: '',
      required: <span style={{ color: '#e55353', paddingLeft: '2px' }}>*</span>,
    },
    {
      id: 'HSN/SAC',
      label: 'HSN/SAC',
      width: 120,
      align: 'left',
      currency: '',
      required: '',
    },

    {
      id: 'Qty',
      label: 'Qty',
      width: 100,
      align: 'left',
      currency: '',
      required: <span style={{ color: '#e55353', paddingLeft: '2px' }}>*</span>,
    },
    {
      id: 'Units',
      label: 'Units',
      width: 120,
      align: 'left',
      currency: '',
      required: <span style={{ color: '#e55353', paddingLeft: '2px' }}>*</span>,
    },
    {
      id: 'Rate',
      label: 'Rate',
      width: 120,
      align: 'right',
      currency: data?.currency?.sign,
      required: <span style={{ color: '#e55353', paddingLeft: '2px' }}>*</span>,
    },
    {
      id: 'Amount',
      label: 'Amount',
      width: 120,
      align: 'right',
      currency: data?.currency?.sign,
      required: '',
    },
    {
      id: 'Discount',
      label: 'Discount',
      width: 120,
      align: 'right',
      currency: data?.currency?.sign,
      required: '',
    },

    {
      id: 'Net Amt',
      label: 'Net Amt',
      width: 120,
      align: 'right',
      currency: data?.currency?.sign,
      required: '',
    },
    {
      id: 'action',
      label: 'Action',
      width: 40,
      align: 'center',
      currency: '',
      required: '',
    },
  ];
  const [openItemModal, setOpenItemModal] = useState(false);
  const [loadingPriceType, setLoadingPriceType] = useState(false);
  const [itemRowFrom, setItemRowFrom] = useState(0);
  const [addEvent, setAddEvent] = useState(false);
  const [openHsnModal, setOpenHsnModal] = useState(false);
  const [hsnParamsID, setHSNParamsID] = useState('');
  const [relatedAmounts, setRelatedAmounts] = useState([]);
  const [priceTypeArr, setPriceTypeArr] = useState([]);
  const [updatetedTableRow, setUpdatedTableRow] = useState([]);
  const [itemName, setItemName] = useState('');
  const { setIsLoading, ListboxProps, PaperComponent } = useInfiniteScroll(listItems, itemRowFrom, setItemRowFrom);
  const { data: ledgerList } = useListAccountMasterv2Query();
  const { filterHSN, setFilterHSN, searchHSNDetails, HSNListboxProps, setRow } = UseHSNMaster({ Type: itemType, Page: 'ITEM' });

  const { gstOrCompositeRate, compositeRate } = useTaxabilityOptions();
  async function formatNumbers(index, value, checkedValue) {
    let updatedTableArr = [...items];

    updatedTableArr[index] = {
      ...updatedTableArr[index],
      [value]: (() => {
        let formattedValue = checkedValue;
        if (formattedValue === '.') {
          formattedValue = '0.00';
        }

        if (!/^-?\d*(\.\d{0,2})?$/.test(formattedValue)) {
          formattedValue = '0';
        }
        if (!isNaN(parseFloat(formattedValue))) {
          formattedValue = parseFloat(formattedValue).toFixed(2);
        }

        return formattedValue;
      })(),
    };

    setItems(updatedTableArr);
  }
  const handleItemCodeChange = async (e, newValue, index) => {
    if (newValue !== null) {
      setRowIndex(index);

      // Functional state update
      setItems((prev) => {
        const updatedTableRow = [...prev];
        updatedTableRow[index] = {
          ...updatedTableRow[index],
          itemcode: newValue,
        };
        return updatedTableRow;
      });

      let promises = [getItems(newValue.value, index)];
      await Promise.all(promises);
    }
  };

  const handleItemCodeInputChange = (e, newValue) => {
    setItemRowFrom(0);
    listItems(newValue || '', 0, 20);
  };

  const handleItemCodeKeyDown = (e, index) => {
    const warMsg = 'Item Code is required';
    const currentId = 'itemCode' + index;
    const nextId = 'itemName' + index;
    const prevID =
      index === 0
        ? Type === 'Pos'
          ? registrationType == 1
            ? 'invoiceDate'
            : 'creditPeriod'
          : Type === 'DebitNote' || Type === 'CreditNote'
          ? registrationType == 1
            ? 'invVoucher'
            : 'creditPeriod'
          : registrationType == 1
          ? 'creditPeriod'
          : 'creditPeriod'
        : 'itemCode' + (index - 1);
    const required = true;
    handleAutoCompleteKeyDown(e, currentId, nextId, required, warMsg, prevID);
  };
  const handleItemNameChange = async (e, newValue, index) => {
    if (newValue !== null) {
      setItemID(newValue.value);
      setRowIndex(index);

      // Functional update for items
      setItems((prev) => {
        const updatedTableRow = [...prev];
        updatedTableRow[index] = {
          ...updatedTableRow[index],
          itemName: newValue,
        };
        return updatedTableRow;
      });

      let promises = [getItems(newValue.value, index)];
      await Promise.all(promises);
    }
  };

  const handleItemNameInputChange = (e, newValue) => {
    setRow(0);
    listItems(newValue || '', 0, 20);
  };

  const handleItemNameKeyDown = (e, index) => {
    const warMsg = 'Item Name is required';
    const currentId = 'itemName' + index;
    const nextId =
      //  registrationType === 1
      // ? "qty" + index
      // : [2, 3, 4].includes(data?.taxability?.value)
      // ? "hsnCode" + index
      // :
      'priceType' + index;
    const prevID = 'itemCode' + index;
    const required = true;

    handleAutoCompleteKeyDown(e, currentId, nextId, required, warMsg, prevID);
  };
  const handlePriceTypeChange = (e, newValue, index) => {
    if (newValue !== null) {
      setRowIndex(index);
      getAmountDetailsByPriceType(newValue, index);
    }
  };

  const handlePriceTypeKeyDown = (e, index) => {
    const warMsg = '';
    const currentId = 'priceType' + index;
    const nextId =
      Type === 'DebitNote' || Type === 'CreditNote'
        ? 'reason' + index
        : companyType == 3
        ? 'hsnCode' + index
        : registrationType === 1
        ? 'qty' + index
        : [2, 3, 5].includes(data?.taxability?.value)
        ? 'hsnCode' + index
        : 'GSTRate' + index;
    const prevID = 'itemName' + index;
    const required = false;

    handleAutoCompleteKeyDown(e, currentId, nextId, required, warMsg, prevID);
  };
  const handleReasonChange = (e, index) => {
    const value = e.target.value;

    // Functional update
    setItems((prev) => {
      const updatedTableRow = [...prev];
      updatedTableRow[index] = {
        ...updatedTableRow[index],
        reason: value === '' ? '' : value,
      };
      return updatedTableRow;
    });

    if (value !== '') {
      setRowIndex(index);
    }
  };

  const handleReasonKeyDown = (e, index) => {
    const warMsg = '';
    const currentId = 'reason' + index;
    const nextId =
      companyType == 3
        ? 'hsnCode' + index
        : registrationType === 1
        ? 'qty' + index
        : [1, 4, 6].includes(data?.taxability?.value)
        ? 'GSTRate' + index
        : 'hsnCode' + index;
    // const prevID =
    //   partyType === "CUSTOMER" ? "priceType" + index : "itemName" + index;
    const prevID = 'priceType' + index;
    const required = false;

    handleTextKeyDown(e, currentId, nextId, required, warMsg, prevID);
  };
  const handleGSTRateChange = (newValue, index, manualGSTFlag) => {
    if (manualGSTFlag === 0) {
      if (newValue) {
        setTableAmountsByGSTRate(newValue, index, manualGSTFlag);
      } else {
        setTableAmountsByManualGTRate(newValue, index, manualGSTFlag);
      }
    } else {
      setTableAmountsByManualGTRate(newValue, index, manualGSTFlag);
    }

    setRowIndex(index);
  };

  const handleGSTRateKeyDown = (e, index) => {
    const warMsg = 'GST Rate is required';
    const currentId = 'GSTRate' + index;
    const nextId = registrationType !== 1 ? 'hsnCode' + index : 'qty' + index;
    const prevID = Type === 'DebitNote' || Type === 'CreditNote' ? 'reason' + index : 'priceType' + index;
    const required = true;

    handleAutoCompleteKeyDown(e, currentId, nextId, required, warMsg, prevID);
  };

  const handleHSNChange = (e, newValue, index) => {
    setRowIndex(index);

    setItems((prev) => {
      const updatedTableRow = [...prev];

      if (newValue !== null) {
        updatedTableRow[index] = {
          ...updatedTableRow[index],
          HSN: newValue,
        };
      } else {
        updatedTableRow[index] = {
          ...updatedTableRow[index],
          HSN: {
            label: '',
            value: '',
            companyID: '',
            hsnID: '',
            codeType: '',
            description: '',
          },
        };
      }

      return updatedTableRow;
    });
  };

  const handleHSNKeyDown = (e, index) => {
    const warMsg = 'HSN/SAC Code is required';
    const currentId = 'hsnCode' + index;
    const nextId = 'qty' + index;
    const prevID =
      Type === 'DebitNote' || Type === 'CreditNote' ? 'reason' + index : companyType == 3 ? 'priceType' + index : 'GSTRate' + index;
    const required =
      Type === 'Sales' &&
      //  &&
      // data.partyCategory !== "UB"
      // EInvoiceFlag &&
      // registrationType !== 1;
      companyType === 2;

    handleAutoCompleteKeyDown(e, currentId, nextId, required, warMsg, prevID);
  };

  const handleHSNInputChange = (e, newValue) => {
    setRow(0);
    searchHSNDetails(newValue || '', 0, 20);
  };
  // const handleQuantityChange = (e, index) => {
  //   const updatedTableRow = [...items];
  //   let value = e.target.value.replace(/,/g, ""); // Remove commas

  //   // Handle special cases for negative numbers
  //   if (value === "0-") value = "-0";
  //   if (value === "-") value = "0";

  //   // Ensure valid numeric input
  //   // if (!/^(-?\d*(?:\.\d*)?)$/.test(value)) return;
  //   const isValid = /^\d{0,10}(\.\d{0,4})?$/.test(value);
  //   if (!isValid) {
  //     // showWarningSnackbar(`Only up to 4 digits allowed before and after decimal.`);
  //     return;
  //   }

  //   if (value !== "" && value !== 0) {
  //     setTableAmountsByQty(value, index);
  //     setRowIndex(index);
  //   } else {
  //     setTableAmountsByQty(0, index);
  //   }
  // };
  const handleQuantityChange = (e, index) => {
    let value = e.target.value.replace(/,/g, ''); // Remove commas

    //LEDX-5066<<
    if (/^0+$/.test(value)) {
      e.target.value = '0';
      value = '0';
    }

    if (/^\d+\.\d{5,}$/.test(value)) {
      value = value.replace(/^(\d+\.\d{4}).*$/, '$1');
      e.target.value = '0';
    }
    //LEDX-5066>>

    if (value === '' || value === '.' || value === '0.') {
      setTableAmountsByQty(value, index); // keep as string for typing
      setRowIndex(index);
      return;
    }

    const isValid = /^(?:\d{1,10})(?:\.\d{0,4})?$/.test(value);
    if (!isValid) {
      return;
    }

    let normalized = value;
    if (/^0+\d/.test(value)) {
      normalized = String(Number(value));
    }
    setTableAmountsByQty(normalized, index);
    setRowIndex(index);
  };
  const handleQuantityBlur = (index) => {
    const updatedTableArr = [...items];
    formatNumbers(index, 'qty', updatedTableArr[index]?.qty);

    if (EInvoiceFlag && itemType === 'SERVICE' && (!updatedTableArr[index].qty || updatedTableArr[index].qty == 0)) {
      setTableAmountsByQty(1, index); // Enforce min value on blur
    }
  };

  const handleQuantityKeyDown = (e, index) => {
    const warMsg = 'Quantity is required';
    const currentId = 'qty' + index;
    // const nextId = "units" + index;
    const nextId = 'rate' + index;
    const prevID =
      registrationType !== 1 && partyType === 'CUSTOMER'
        ? 'hsnCode' + index
        : Type === 'CreditNote' || Type === 'DebitNote'
        ? 'reason' + index
        : 'itemName' + index;
    const required = !(EInvoiceFlag && itemType === 'SERVICE');

    handleTextKeyDown(e, currentId, nextId, required, warMsg, prevID);
  };

  const handleUnitsChange = (event, newValue, index) => {
    setRowIndex(index);

    if (newValue) {
      setItems((prev) => {
        const updatedTableRow = [...prev];
        updatedTableRow[index] = {
          ...updatedTableRow[index],
          units: newValue.value,
        };
        return updatedTableRow;
      });
    }
  };

  const handleUnitsKeyDown = (e, index) => {
    const warMsg = 'Unit is required';
    const currentId = 'units' + index;
    const nextId = 'rate' + index;
    const prevID = 'qty' + index;
    const required = !(EInvoiceFlag && itemType === 'SERVICE');

    handleAutoCompleteKeyDown(e, currentId, nextId, required, warMsg, prevID);
  };
  const handleRateChange = (e, index) => {
    const updatedTableRow = [...items];
    let value = e.target.value.replace(/,/g, '');
    let discountByValue=0;
    let amt=0;

    if (!/^-?\d*(?:\.\d*)?$/.test(value) || !/^-?\d*\.?\d{0,2}$/.test(value)) {
      return;
    }
     amt = Number(updatedTableRow[index]?.qty) * Number(value);
        //LEDX-5577
          if(updatedTableRow[index]?.manualDiscount === false){
          if( updatedTableRow[index]?.discountType === 'Percentage' && updatedTableRow[index]?.discountRate!=='' && Number(updatedTableRow[index]?.discountRate)>0 ){

             discountByValue = (Number(amt) * Number(updatedTableRow[index]?.discountRate)) / 100;
            
    discountByValue = Number(Number(discountByValue).toFixed(2));
          }else{
             
          discountByValue = Number(updatedTableRow[index]?.qty) * Number(updatedTableRow[index]?.autoDiscount??0);
          }
        }else{
       discountByValue = Number(updatedTableRow[index]?.dicount);
        }
          
 //LEDX-5577
    const numericValue = parseFloat(value);
    const maxLimit = 10_000_000_00; // 10 billion
    const minLimit = Number(discountByValue);

    if (numericValue > maxLimit) return;

    if (minLimit > 0 && amt <= minLimit) {
      
      showWarningSnackbar('Discount should not be greater than amount applied');
      return;
    }

    setTableAmountsByRate(value || 0, index);
    setRowIndex(index);
  };

  const handleRateBlur = (index) => {
    const updatedTableArr = [...items];
    formatNumbers(index, 'rate', updatedTableArr[index]?.rate);
  };

  const handleRateKeyDown = (e, index) => {
    const warMsg = 'Rate is required';
    const currentId = 'rate' + index;
    const nextId = 'amount' + index;
    // const prevID = "units" + index;
    const prevID = 'qty' + index;
    const required = true;

    handleTextKeyDown(e, currentId, nextId, required, warMsg, prevID);
  };
  const handleDiscountChange = (e, index) => {
    const updatedTableArr = [...items];
    let value = e.target.value.replace(/,/g, '');

    if (!/^-?\d*(?:\.\d*)?$/.test(value) || !/^-?\d*\.?\d{0,2}$/.test(value)) {
      return;
    }

    if (Number(value) >= Number(updatedTableArr[index]?.amount)) {
      showWarningSnackbar('Discount should not be greater than amount applied');
      return;
    }

    setTableAmountsByDiscount(value || 0, index);
    setRowIndex(index);
  };

  const handleDiscountBlur = (index) => {
    const updatedTableArr = [...items];
    formatNumbers(index, 'dicount', updatedTableArr[index]?.dicount);
  };

  const handleDiscountKeyDown = (e, index) => {
    const warMsg = '';
    const currentId = 'dicount' + index;
    const nextId = registrationType == 1 ? 'netAmount' + index : 'taxableAMount' + index;
    const prevID = 'amount' + index;
    const required = false;

    handleTextKeyDown(e, currentId, nextId, required, warMsg, prevID);
  };
  const handleGstCessChange = (e, index) => {
    let value = e.target.value.replace(/,/g, '');
    if (!/^\d*\.?\d*$/.test(value)) return;
    const numericValue = parseFloat(value);
    const maxLimit = 10000000000; // 10 billion

    if (numericValue > maxLimit) {
      return;
    }

    setTableAmountsByGStCess(value || 0, index);
    setRowIndex(index);
  };

  const handleGstCessBlur = (index) => {
    const updatedTableArr = [...items];
    formatNumbers(index, 'GSTCess', updatedTableArr[index]?.GSTCess);
  };
  const handleGstAmtBlur = (index) => {
    const updatedTableArr = [...items];
    formatNumbers(index, 'IGST', updatedTableArr[index]?.IGST);
  };

  const handleGstCessKeyDown = (e, index) => {
    const warMsg = '';
    const currentId = 'gstCess' + index;
    const nextId = 'netAmount' + index;
    const prevID = 'IGST' + index;
    const required = false;

    handleTextKeyDown(e, currentId, nextId, required, warMsg, prevID);
  };
  async function getTableDataOfSales(invoiceEntry) {
    if (invoiceEntry?.relatedinvoicelineitems?.length > 0) {
      // setBackdropOpen(true);
      let arr = [];
      let itemName = {};
      let itemCodeObj = {};
      let accountobj = {};
      let hsnCode = {
        label: '',
        value: '',
        companyID: '',
        hsnID: '',
        codeType: '',
        description: '',
      };
      let hsnobj254 = {};
      let taxObj = { label: '', value: '' };

      await Promise.all(
        invoiceEntry?.relatedinvoicelineitems.map(async (ele) => {
          ele.taxAmount = Number(ele.quantity) * Number(ele.itemrate) - Number(ele.itemdiscount);
          if (ele?.manualgst === 0) {
            if ([2, 3, 5, 7, 9].includes(Number(invoiceEntry?.invoicetaxabletypecd))) {
              ele.IGST = 0;
            } else {
              ele.IGST = (Number(ele.taxAmount) * Number(ele.gstrate)) / 100;
              ele.IGST = Number(ele.IGST) / 2;
              ele.IGST = Math.round(ele.IGST * 100) / 100;
              ele.IGST = ele.IGST * 2;
              ele.IGST = ele.IGST > 0 ? ele.IGST : 0;
            }
          } else {
            ele.IGST = ele?.gstamount;
          }

          if (ele.hsnsaccode != 0) {
            hsnCode = {
              label: `${ele.hsnsaccode} - ${ele.hsndescription}`,
              value: `${ele.hsnsaccode}`,
              companyID: ele.companyid,
              hsnID: ele.hsnsacid,
              codeType: ele.hsncodetype,
              description: ele.hsndescription,
            };
          }

          itemName = { label: ele.itemname, value: ele.itemid };
          itemCodeObj = { label: ele.itemcode, value: ele.itemid };

          accountobj = {
            label: ele.salesaccountname,
            value: ele.salesaccountid,
          };
          accountobj = {
            label: ele.salesaccountname,
            value: ele.salesaccountid,
          };
          let initialItemCess = 0;
          let initialItemDisCount = 0;
          if (ele?.manualcess == 0) {
            initialItemCess = Number(ele?.cessamount) / Number(ele?.quantity);
            // setCurrentCessValue(initialItemCess)
          }
          if (ele.manualdiscount == 0) {
            initialItemDisCount = Number(ele.itemdiscount) / Number(ele?.quantity);
            // setItemDiscount(initialItemDisCount)
          }

          arr.push({
            id: ele.invoiceitemid,
            itemCode: itemCodeObj,
            HSN: hsnCode,
            priceType: { label: ele?.pricetype, value: ele?.pricetypeid },
            ledgerAccount: accountobj,
            name: itemName,
            qty: ele.quantity,
            units: ele.unittypecd,
            taxability: taxObj,
            rate: ele.itemrate,
            amount: ele.itemamount,
            dicount: ele.itemdiscount,
            taxableAMount: ele.taxAmount,
            manualDiscount: ele?.manualdiscount == 1 ? true : false,
            manualCess: ele.manualcess,
            autoCess: initialItemCess,
            autoDiscount: initialItemDisCount,
            GSTRate: ele?.gstrate,
            manualGSTFlag: ele?.manualgst,
            IGST: ele.IGST,
            CGST: '0',
            SGST: '0',
            GSTCess: [2, 3, 5, 7, 9].includes(Number(invoiceEntry?.invoicetaxabletypecd)) ? 0 : ele?.cessamount,
            netAmount: [2, 3, 5, 7, 4, 9].includes(Number(invoiceEntry?.invoicetaxabletypecd)) ? ele?.taxAmount : ele.netamount,
            itemType: ele.itemtype,
            invoiceitemid: ele?.invoiceitemid,
            cessType:ele.cesstype,
            discountType:ele?.discounttype,
            discountRate:ele.discountrate,
          
            cessRate:ele.cessrate,
            editable: false,
            new: false,
            priceTypeArr: [],
          });
        })
      );

      const sortedArray = [...arr].sort((a, b) => a.id - b.id);
      setItems([...sortedArray, newItemObj]);
      if (setInitItemTableDta) {
        setInitItemTableDta([...sortedArray, newItemObj]);
      }

      setBackdropOpen(false);
    }
    setBackdropOpen(false);
  }
  async function getTableDataOfPurchase(invoiceEntry) {
    if (invoiceEntry?.relatedpurchaselineitems?.length > 0) {
      // setBackdropOpen(true);
      let arr = [];

      await Promise.all(
        invoiceEntry?.relatedpurchaselineitems?.map(async (ele, ind) => {
          ele.relateditemmaster?.map((item) => {
            if (ele.itemid == item.itemid) {
              ele.itemtype = item.itemtype;
            }
          });

          ele.taxAmount = Number(ele.itemquantity) * Number(ele.itemrate) - Number(ele.itemdiscount);
          if (ele?.manualgst === 0) {
            if ([2, 3, 5, 7, 9].includes(Number(invoiceEntry?.purchasegsttypecd))) {
              ele.IGST = 0;
            } else {
              ele.IGST = (Number(ele.taxAmount) * Number(ele.gstrate)) / 100;
              ele.IGST = Number(ele.IGST) / 2;
              ele.IGST = Math.round(ele.IGST * 100) / 100;
              ele.IGST = ele.IGST * 2;
              ele.IGST = ele.IGST > 0 ? ele.IGST : 0;
            }
          } else {
            ele.IGST = ele?.gstamount;
          }

          let hsnCode = {
            label: '',
            value: '',
            companyID: '',
            hsnID: '',
            codeType: '',
            description: '',
          };
          let itemName = {};
          let itemcode = {};
          if (ele.hsncode != 0) {
            hsnCode = {
              label: `${ele.hsncode} - ${ele.hsndescription}`,
              value: `${ele.hsncode}`,
              companyID: ele.companyid,
              hsnID: ele.hsnsacid,
              codeType: ele.hsncodetype,
              description: ele.hsndescription,
            };
          }
          let accountobj = { label: '', value: '' };

          accountobj = {
            label: ele?.purchaseaccountname,
            value: ele?.purchaseaccountid,
          };

          itemName = { label: ele.itemname, value: ele.itemid };
          itemcode = { label: ele.itemcode, value: ele.itemid };

          let taxObj = { label: '', value: '' };
          let initialItemCess = 0;
          if (ele?.manualcess == 0) {
            initialItemCess = Number(ele?.cessamount) / Number(ele?.itemquantity);
            // setCurrentCessValue(initialItemCess)
          }
          let initialItemDisCount = 0;
          if (ele.manualdiscount == 0) {
            initialItemDisCount = Number(ele.itemdiscount) / Number(ele?.itemquantity);
            // setItemDiscount(initialItemDisCount)
          }
          arr.push({
            id: ele.purchaseitemid,
            itemCode: itemcode,
            name: itemName,
            ledgerAccount: accountobj,
            HSN: hsnCode,
            priceType: { label: ele?.pricetype, value: ele?.pricetypeid },
            taxability: taxObj,
            qty: ele.itemquantity,
            units: ele.unittypecd,
            rate: ele.itemrate,
            amount: ele.itemamount,
            dicount: ele.itemdiscount,
            taxableAMount: ele.taxAmount,
            GSTRate: ele?.gstrate,
            manualGSTFlag: ele?.manualgst,
            IGST: ele.IGST,
            CGST: '0',
            SGST: '0',
            GSTCess: [2, 3, 5, 7, 9].includes(Number(invoiceEntry?.purchasegsttypecd)) ? 0 : ele?.cessamount,
            netAmount: [2, 3, 5, 7, 9].includes(Number(invoiceEntry?.purchasegsttypecd)) ? ele?.taxAmount : ele.netamount,
            itemType: ele.itemtype,
            purchaseitemid: ele?.purchaseitemid,
            manualDiscount: ele?.manualdiscount == 1 ? true : false,
            manualCess: ele.manualcess,
            autoCess: initialItemCess,
            autoDiscount: initialItemDisCount,
              cessType:ele.cesstype,
          
          cessRate:ele.cessrate,
          discountType:ele?.discounttype,
            discountRate:ele.discountrate,
            editable: false,
            new: false,
          });
        })
      );
      const sortedArray = [...arr].sort((a, b) => a.id - b.id);
      setItems([...sortedArray, newItemObj]);
      if (setInitItemTableDta) {
        setInitItemTableDta([...sortedArray, newItemObj]);
      }
      setBackdropOpen(false);
    }
  }
  async function getTableDataOfCrDr(invoiceEntry) {
    try {
      if (invoiceEntry?.relatedcrdrnotelineitems.length > 0) {
        // setBackdropOpen(true);
        let arr = [];
        await Promise.all(
          invoiceEntry?.relatedcrdrnotelineitems.map(async (ele, ind) => {
            let hsnCode = {
              label: '',
              value: '',
              companyID: '',
              hsnID: '',
              codeType: '',
              description: '',
            };
            let itemName = { label: '', value: '' };
            let itemcode = { label: '', value: '' };
            let hsnobj254 = {};

            let accountobj = {};
            if (invoiceEntry?.partytypecd === 'SUPPLIER') {
              accountobj = {
                label: ele?.purchaseaccountname,
                value: ele?.purchaseaccountid,
              };
            } else {
              accountobj = {
                label: ele?.salesaccountname,
                value: ele?.salesaccountid,
              };
            }

            itemName = { label: ele.itemname, value: ele.itemid };

            itemcode = { label: ele.itemcode, value: ele.itemid };

            if (ele.hsnsaccode != 0) {
              hsnCode = {
                label: `${ele.hsnsaccode} - ${ele.hsndescription}`,
                value: `${ele.hsnsaccode}`,
                companyID: ele.companyid,
                hsnID: ele.hsnsacid,
                codeType: ele.hsncodetype,
                description: ele.hsndescription,
              };
            }
            let taxObj = { label: '', value: '' };

            ele.taxAmount = Number(ele.quantity) * Number(ele.itemrate) - Number(ele.itemdiscount);
            if (ele?.manualgst === 0) {
              if ([2, 3, 5, 7, 9].includes(Number(invoiceEntry?.gsttypecd))) {
                ele.IGST = 0;
              } else {
                ele.IGST = (Number(ele.taxAmount) * Number(ele.gstrate)) / 100;
                ele.IGST = Number(ele.IGST) / 2;
                ele.IGST = Math.round(ele.IGST * 100) / 100;
                ele.IGST = ele.IGST * 2;
                ele.IGST = ele.IGST > 0 ? ele.IGST : 0;
              }
            } else {
              ele.IGST = ele?.gstamount;
            }
            let initialItemCess = 0;
            if (ele?.manualcess == 0) {
              initialItemCess = Number(ele?.gstcess) / Number(ele?.quantity);
              // setCurrentCessValue(initialItemCess)
            }
            let initialItemDisCount = 0;
            if (ele.manualdiscount == 0) {
              initialItemDisCount = Number(ele.itemdiscount) / Number(ele?.quantity);
              // setItemDiscount(initialItemDisCount)
            }
            const taxTypes = invoiceEntry?.partytypecd === 'CUSTOMER' || Type === 'Pos' ? [2, 3, 5, 4, 7, 9] : [2, 3, 5, 7, 9];
            arr.push({
              id: ele.crdrnoteitemid,
              itemCode: itemcode,
              name: itemName,
              HSN: hsnCode,
              qty: ele.quantity,
              priceType: { label: ele?.pricetype, value: ele?.pricetypeid },
              ledgerAccount: accountobj,
              units: ele.unittypecd,
              rate: ele.itemrate,
              amount: ele.itemamount,
              taxability: taxObj,
              reason: ele.reason ?? '',
              dicount: ele.itemdiscount,
              taxableAMount: ele.taxAmount,
              GSTRate: ele.gstrate,
              manualGSTFlag: ele?.manualgst,
              IGST: ele.IGST || 0,
              CGST: '0',
              SGST: '0',
              manualDiscount: ele?.manualdiscount == 1 ? true : false,
              manualCess: ele.manualcess,
              autoCess: initialItemCess,
              autoDiscount: initialItemDisCount,
              GSTCess: [2, 3, 5, 7, 9].includes(Number(invoiceEntry?.gsttypecd)) ? 0 : ele.gstcess,
              // netAmount:[2, 3, 5, 7, 4, 9].includes(Number(invoiceEntry?.gsttypecd))?ele?.taxAmount: ele.netamount,
              netAmount: taxTypes.includes(Number(invoiceEntry?.gsttypecd)) ? ele?.taxAmount : ele.netamount,
              itemType: ele.itemtype,
              crdrnoteitemid: ele?.crdrnoteitemid,
                cessType:ele.cesstype,
          
          cessRate:ele.cessrate,
          discountType:ele?.discounttype,
            discountRate:ele.discountrate,
              editable: false,
              new: false,
            });
          })
        );
        const sortedArray = [...arr].sort((a, b) => a.id - b.id);
        setItems([...sortedArray, newItemObj]);
        if (setInitItemTableDta) {
          setInitItemTableDta([...sortedArray, newItemObj]);
        }
        setBackdropOpen(false);
      }
    } catch (error) {
      setBackdropOpen(false);
      console.log('error', error);
    }
  }
  function saveChangesInRows(index) {
    let isvalid = true;
    let requireds = [];
    let invalids = [];
    let errorArr = [];
    let invalidDiscount = [];
    let EInvoiceFlag = getCompany?.relatedcompanydetailsnew?.[0]?.einvoiceflag;

    const updatedTableRow = [...items];
    updatedTableRow.map((ele, ind) => {
      if (ele?.itemCode?.value === '') {
        isvalid = false;
        errorArr.push('itemCode' + ind);
        requireds.push('Item Code');
      }
      if (ele?.name?.value === '') {
        isvalid = false;
        errorArr.push('itemName' + ind);
        requireds.push('Item Name');
      }
      if (EInvoiceFlag && itemType !== 'SERVICE') {
        if (ele?.qty === 0 || ele?.qty === '0' || ele?.qty === '') {
          isvalid = false;
          errorArr.push('qty' + ind);
          requireds.push('Quantity');
        }
      }
      if (ele?.qty !== '' && !new RegExp(/^(?=.+)(?:[1-9]\d*|0\d*)?(?:\.\d+)?$/).test(ele?.qty)) {
        isvalid = false;
        errorArr.push('qty' + ind);
        invalids.push(' Quantity');
      }

      if (ele?.qty !== 0 && (ele?.rate == '' || ele?.rate == 0)) {
        isvalid = false;
        errorArr.push('rate' + ind);
        requireds.push('Rate');
      }

      if (registrationType !== 1) {
        if (
          data?.taxability?.value == 1 ||
          data?.taxability?.value == 4 ||
          data?.taxability?.value == 6 ||
          data?.taxability?.value == 8 ||
          data?.taxability?.value == 9 ||
          data?.taxability?.value == 7 ||
          data?.taxability?.value === ''
        ) {
          if (ele?.GSTRate === '') {
            isvalid = false;
            errorArr.push('GSTRate' + ind);
            requireds.push('GST Rate');
          }
        }
        if (
          (ele?.HSN?.value === '' || ele?.HSN?.value === undefined || ele?.HSN?.value === null) &&
          // EInvoiceFlag &&
          // Type === "Sales"
          companyType === 2
          // && data.partyCategory !== "UB"
        ) {
          isvalid = false;
          errorArr.push('hsnCode' + ind);
          requireds.push('HSN/SAC Code');
        }
      }
      if (ele?.dicount !== '' && Number(ele?.dicount) > Number(ele?.amount)) {
        isvalid = false;
        errorArr.push('dicount' + ind);
        invalidDiscount.push(' Discount');
      }
      return isvalid;
    });
    setTableErrArr(errorArr);
    setItemValid(isvalid);
    if (isvalid) {
      let arr = [...updatedTableRow];
      // arr[index].new = false;
      let taxArr = [];
      let cusTaxArr = [];
      setItems([...arr, newItemObj]);
      setAddEvent(true);
      handleResetScroll();
      setRowIndex('');
    } else {
      setIsFocusItemRow(false);
      if (requireds.length === 1) {
        showWarningSnackbar(`${requireds}` + ' ' + 'is required');
      }
      if (requireds.length > 1) {
        showWarningSnackbar(`${requireds}` + ' ' + 'are required');
      }
    }
  }

  function closeChangesInRows(ind) {
    let arr = [...items].filter((item, index) => {
      if (ind != index) {
        return item;
      }
    });
    setItems(arr);
  } 
  function setTableAmountsByQty(value, index) {
    let netAmt = 0;
    let taxAmt = 0;
    let amt = 0;
    let igstAmt = 0;
    let discountByValue = 0;
    let cessAmt=0;
    const taxTypes = partyType === 'CUSTOMER' || Type === 'Pos' ? [2, 3, 5, 4, 7, 9] : [2, 3, 5, 7, 9];

    setItems((prev) => {
      const updatedTableRow = [...prev];

      if (value == 0) {
        updatedTableRow[index] = {
          ...updatedTableRow[index],
          qty: 0,
          GSTCess: 0,
          dicount: 0,
          amount: 0,
          taxableAMount: 0,
          IGST: 0,
          netAmount: 0,
        };
        return updatedTableRow;
      }

      if (updatedTableRow[index]?.rate !== 0) {
        if (value !== '' && Number(updatedTableRow[index]?.rate) !== 0) {
          amt = Number(value) * Number(updatedTableRow[index]?.rate);

          if (Number(value) * Number(updatedTableRow[index]?.autoDiscount) > Number(amt)) {
            showWarningSnackbar('Discount should not be greater than amount applied');
          }
          //LEDX-5577
          if(updatedTableRow[index]?.manualDiscount === false){
          if( updatedTableRow[index]?.discountType === 'Percentage' && updatedTableRow[index]?.discountRate!=='' && Number(updatedTableRow[index]?.discountRate)>0 ){
             discountByValue = (Number(amt) * Number(updatedTableRow[index]?.discountRate)) / 100;
    discountByValue = Number(Number(discountByValue).toFixed(2));
          }else{
          discountByValue = Number(value) * Number(updatedTableRow[index]?.autoDiscount??0);
          }
        }else{
       discountByValue = Number(updatedTableRow[index]?.dicount);
        }
          
 //LEDX-5577
          taxAmt =
            Number(amt) -
            Number(discountByValue); 
        }
        if (updatedTableRow[index]?.manualGSTFlag === 0) {
          if (
            updatedTableRow[index]?.GSTRate !== '' &&
            Number(updatedTableRow[index]?.GSTRate) > 0 &&
            ![2, 3, 5, 7, 9].includes(data?.taxability?.value)
          ) {
            igstAmt = (Number(taxAmt) * Number(updatedTableRow[index]?.GSTRate)) / 100;
            igstAmt = Number(igstAmt) / 2;
            igstAmt = Math.round(igstAmt * 100) / 100;
            igstAmt = igstAmt * 2;
          }
        } else {
          igstAmt = updatedTableRow[index]?.IGST;
        }
      

if (
  (registrationType === 3 && partyType === 'CUSTOMER') ||
  (data.reverseChargeFlag == 1 && (partyType === 'CUSTOMER' || Type === 'Pos')) ||
  taxTypes.includes(data?.taxability?.value)
) {
  cessAmt = 0;
} else if (updatedTableRow[index]?.manualCess === 0) {
  if (
    updatedTableRow[index]?.cessRate !== '' &&
    Number(updatedTableRow[index]?.cessRate) > 0 &&
    updatedTableRow[index]?.cessType === 'Percentage' &&
    ![2, 3, 5, 7, 9].includes(data?.taxability?.value)
  ) {
    cessAmt = (Number(taxAmt) * Number(updatedTableRow[index]?.cessRate)) / 100;
    cessAmt = Number(Number(cessAmt).toFixed(2));
  } else {
    cessAmt = Number(value) * Number(updatedTableRow[index]?.autoCess??0);
  }
} else {
  cessAmt = Number(updatedTableRow[index]?.GSTCess);
}

        if (registrationType === 1 && Type === 'Purchase') {
          netAmt = Number(taxAmt) + Number(igstAmt);
        } else {
          netAmt =
            Number(taxAmt) +
            Number(cessAmt //LEDX-5418
              // updatedTableRow[index]?.manualCess === 0
              //   ? Number(value) * Number(updatedTableRow[index]?.autoCess)
              //   : Number(updatedTableRow[index]?.GSTCess)
            ) +
            Number(igstAmt);
        }
        if (netAmt > 999999999) {
          showWarningSnackbar('The Net Amount should be less than 100 crore');
          return prev;
        }
        updatedTableRow[index] = {
          ...updatedTableRow[index],
          qty: value,
       
          GSTCess:cessAmt,
          // dicount:
          //   updatedTableRow[index]?.manualDiscount === false
          //     ? Number(value) * Number(updatedTableRow[index]?.autoDiscount)
          //     : Number(updatedTableRow[index]?.dicount),
          dicount:Number(discountByValue),//LEDX-5577
          amount: amt,
          taxableAMount: taxAmt,
          IGST: igstAmt,
          netAmount:
            (registrationType === 3 && partyType === 'CUSTOMER') ||
            (data.reverseChargeFlag == 1 && (partyType === 'CUSTOMER' || Type === 'Pos')) ||
            taxTypes.includes(data?.taxability?.value)
              ? taxAmt
              : netAmt,
          manualGSTFlag: updatedTableRow[index]?.manualGSTFlag,
        };
      } else {
        updatedTableRow[index] = {
          ...updatedTableRow[index],
          qty: value,
          // dicount: Number(value) * Number(updatedTableRow[index]?.autoDiscount),
          dicount:Number(discountByValue),//LEDX-5577
          netAmount: 0,
          taxAmount: 0,
          manualGSTFlag: 0,
        };
      }

      return updatedTableRow;
    });
  }

  function setTableAmountsByRate(value, index) {
    let netAmt = 0;
    let taxAmt = 0;
    let amt = 0;
    let igstAmt = 0;
    let sgstAmt = 0;
    let cgstAmt = 0;
    let cessAmt=0;
    let discountByValue=0;//LEDX-5577

    const taxTypes = partyType === 'CUSTOMER' || Type === 'Pos' ? [2, 3, 5, 4, 7, 9] : [2, 3, 5, 7, 9];

    setItems((prev) => {
      const updatedTableRow = [...prev];

      if (value == 0) {
        updatedTableRow[index] = {
          ...updatedTableRow[index],
          rate: (value),
          GSTCess: 0,
          dicount: 0,
          amount: 0,
          taxableAMount: 0,
          IGST: 0,
          netAmount: 0,
        };
        return updatedTableRow;
      }

      if (updatedTableRow[index]?.qty !== '' && value !== 0) {
        amt = Number(updatedTableRow[index]?.qty) * Number(value);
        //LEDX-5577
          if(updatedTableRow[index]?.manualDiscount === false){
          if( updatedTableRow[index]?.discountType === 'Percentage' && updatedTableRow[index]?.discountRate!=='' && Number(updatedTableRow[index]?.discountRate)>0 ){
             discountByValue = (Number(amt) * Number(updatedTableRow[index]?.discountRate)) / 100;
    discountByValue = Number(Number(discountByValue).toFixed(2));
          }else{
          discountByValue =Number(updatedTableRow[index]?.qty) * Number(updatedTableRow[index]?.autoDiscount??0);
          }
        }else{
       discountByValue = Number(updatedTableRow[index]?.dicount);
        }
          
 //LEDX-5577
        // taxAmt = Number(amt) - Number(updatedTableRow[index]?.dicount);
        taxAmt = Number(amt) - Number(discountByValue);//LEDX-5577
        if (updatedTableRow[index]?.manualGSTFlag === 0) {
          if (
            updatedTableRow[index]?.GSTRate !== '' &&
            Number(updatedTableRow[index]?.GSTRate) > 0 &&
            ![2, 3, 5, 7, 9].includes(data?.taxability?.value)
          ) {
            igstAmt = (Number(taxAmt) * Number(updatedTableRow[index]?.GSTRate)) / 100;
            igstAmt = Number(igstAmt) / 2;
            igstAmt = Math.round(igstAmt * 100) / 100;
            igstAmt = igstAmt * 2;
          }
        } else {
          igstAmt = updatedTableRow[index]?.IGST;
        }
        
if (updatedTableRow[index]?.manualCess === 0) {
          if (
            updatedTableRow[index]?.cessRate !== '' &&
            Number(updatedTableRow[index]?.cessRate) > 0 &&  updatedTableRow[index]?.cessType==="Percentage" && ![2, 3, 5, 7, 9].includes(data?.taxability?.value)
          ) {
            cessAmt = (Number(taxAmt) * Number(updatedTableRow[index]?.cessRate)) / 100;
            cessAmt = Number(Number(cessAmt).toFixed(2));

           
          }else{
              cessAmt = updatedTableRow[index]?.GSTCess;
          }
        } else {
          cessAmt = updatedTableRow[index]?.GSTCess;
        }
        if (registrationType === 1 && Type === 'Purchase') {
          netAmt = Number(taxAmt);
        } else {
          netAmt = Number(taxAmt) + Number(cessAmt) + Number(igstAmt);
        }
        if (netAmt > 999999999) {
          showWarningSnackbar('The Net Amount should be less than 100 crore');
          return prev;
        }
        updatedTableRow[index] = {
          ...updatedTableRow[index],
          rate: value,
          amount: amt,
          taxableAMount: taxAmt,
          IGST: igstAmt,
          SGST: sgstAmt,
          CGST: cgstAmt,
          GSTCess:cessAmt,
          dicount:Number(discountByValue),//LEDX-5577
          netAmount:
            (registrationType === 3 && partyType === 'CUSTOMER') ||
            (data.reverseChargeFlag == 1 && (partyType === 'CUSTOMER' || Type === 'Pos')) ||
            taxTypes.includes(data?.taxability?.value)
              ? taxAmt
              : netAmt,
          manualGSTFlag: updatedTableRow[index]?.manualGSTFlag,
          manualCess:updatedTableRow[index]?.manualCess,
          manualDiscount:updatedTableRow[index]?.manualDiscount
        };
      } else {
        updatedTableRow[index] = {
          ...updatedTableRow[index],
          rate: value,
          amount: 0,
          taxableAMount: 0,
          IGST: 0,
          expiredtimestamp: 0,
          SGST: 0,
          CGST: 0,
          dicount:0,//LEDX-5577
          netAmount: 0,
          manualGSTFlag: 0,
        };
      }

      return updatedTableRow;
    });
  }

  function setTableAmountsByGStCess(value, index) {
    let netAmt = 0;
    let taxAmt = 0;
    let amt = 0;
    let igstAmt = 0;
    const taxTypes = partyType === 'CUSTOMER' || Type === 'Pos' ? [2, 3, 5, 4, 7, 9] : [2, 3, 5, 7, 9];

    setItems((prev) => {
      const updatedTableRow = [...prev];

      if (updatedTableRow[index]?.rate !== 0) {
        if (updatedTableRow[index]?.qty !== '' && updatedTableRow[index]?.rate !== 0) {
          amt = Number(updatedTableRow[index]?.qty) * Number(updatedTableRow[index]?.rate);
          taxAmt = Number(amt) - Number(updatedTableRow[index]?.dicount);
          if (updatedTableRow[index]?.manualGSTFlag === 0) {
            if (
              updatedTableRow[index]?.GSTRate !== '' &&
              Number(updatedTableRow[index]?.GSTRate) > 0 &&
              ![2, 3, 5, 7, 9].includes(data?.taxability?.value)
            ) {
              igstAmt = (Number(updatedTableRow[index]?.taxableAMount) * Number(updatedTableRow[index]?.GSTRate)) / 100;
              igstAmt = Number(igstAmt) / 2;
              igstAmt = Math.round(igstAmt * 100) / 100;
              igstAmt = igstAmt * 2;
            }
          } else {
            igstAmt = updatedTableRow[index]?.IGST;
          }

          netAmt = Number(taxAmt) + Number(value) + Number(igstAmt);
          if (netAmt > 999999999) {
            showWarningSnackbar('The Net Amount should be less than 100 crore');
            return prev;
          }
          updatedTableRow[index] = {
            ...updatedTableRow[index],
            GSTCess: value,
            manualCess: 1,
            amount: amt,
            taxableAMount: taxAmt,
            IGST: igstAmt,
            netAmount:
              (registrationType === 3 && partyType === 'CUSTOMER') ||
              (data.reverseChargeFlag == 1 && (partyType === 'CUSTOMER' || Type === 'Pos')) ||
              taxTypes.includes(data?.taxability?.value)
                ? taxAmt
                : netAmt,
            manualGSTFlag: updatedTableRow[index]?.manualGSTFlag,
          };
        }
      } else {
        updatedTableRow[index] = {
          ...updatedTableRow[index],
          GSTCess: value,
          amount: 0,
          taxableAMount: 0,
          IGST: 0,
          expiredtimestamp: 0,
          netAmount: 0,
          manualGSTFlag: 0,
        };
      }

      return updatedTableRow;
    });
  }

  function setTableAmountsByGSTRate(value, index, manualGSTFlag) {
    let netAmt = 0;
    let taxAmt = 0;
    let amt = 0;
    let igstAmt = 0;
    const taxTypes = partyType === 'CUSTOMER' || Type === 'Pos' ? [2, 3, 5, 4, 7, 9] : [2, 3, 5, 7, 9];

    setItems((prev) => {
      const updatedTableRow = [...prev];

      if (updatedTableRow[index]?.qty !== '' && updatedTableRow[index]?.rate !== 0) {
        amt = Number(updatedTableRow[index]?.qty) * Number(updatedTableRow[index]?.rate);

        if (value?.id !== '' && Number(value?.id) > 0 && ![2, 3, 5, 7, 9].includes(data?.taxability?.value)) {
          igstAmt = (Number(updatedTableRow[index]?.taxableAMount) * Number(value?.id)) / 100;
          igstAmt = Number(igstAmt) / 2;
          igstAmt = Math.round(igstAmt * 100) / 100;
          igstAmt = igstAmt * 2;
        }

        taxAmt = Number(amt) - Number(updatedTableRow[index]?.dicount);

        if (registrationType === 1 && Type === 'Purchase') {
          netAmt = Number(taxAmt) + Number(igstAmt);
        } else {
          netAmt = Number(taxAmt) + Number(updatedTableRow[index]?.GSTCess) + Number(igstAmt);
        }
        if (netAmt > 999999999) {
          showWarningSnackbar('The Net Amount should be less than 100 crore');
          return prev;
        }
        updatedTableRow[index] = {
          ...updatedTableRow[index],
          GSTRate: value.id !== '' ? value.id : '',
          amount: amt,
          taxableAMount: taxAmt,
          IGST: igstAmt,
          netAmount:
            (registrationType == 3 && partyType === 'CUSTOMER') ||
            (data.reverseChargeFlag == 1 && (partyType === 'CUSTOMER' || Type === 'Pos')) ||
            taxTypes.includes(data?.taxability?.value)
              ? taxAmt
              : netAmt,
          manualGSTFlag: manualGSTFlag,
        };
      } else {
        updatedTableRow[index] = {
          ...updatedTableRow[index],
          GSTRate: value.id !== '' ? value.id : '',
          amount: 0,
          taxableAMount: 0,
          IGST: 0,
          expiredtimestamp: 0,
          netAmount: 0,
          manualGSTFlag: manualGSTFlag,

        };
      }

      return updatedTableRow;
    });
  }
  function setTableAmountsByManualGTRate(value, index, manualGSTFlag) {
    let netAmt = 0;
    let taxAmt = 0;
    let amt = 0;
    let igstAmt = 0;
    const taxTypes = partyType === 'CUSTOMER' || Type === 'Pos' ? [2, 3, 5, 4, 7, 9] : [2, 3, 5, 7, 9];

    setItems((prev) => {
      const updatedTableRow = [...prev];

      if (updatedTableRow[index]?.qty !== '' && updatedTableRow[index]?.rate !== 0) {
        amt = Number(updatedTableRow[index]?.qty) * Number(updatedTableRow[index]?.rate);

        if (value && ![2, 3, 5, 7, 9].includes(data?.taxability?.value)) {
          igstAmt = value;
        } else {
          igstAmt = 0;
        }

        taxAmt = Number(amt) - Number(updatedTableRow[index]?.dicount);

        if (registrationType === 1 && Type === 'Purchase') {
          netAmt = Number(taxAmt) + Number(igstAmt);
        } else {
          netAmt = Number(taxAmt) + Number(updatedTableRow[index]?.GSTCess) + Number(igstAmt);
        }
        if (netAmt > 999999999) {
          showWarningSnackbar('The Net Amount should be less than 100 crore');
          return prev;
        }
        updatedTableRow[index] = {
          ...updatedTableRow[index],
          amount: amt,
          taxableAMount: taxAmt,
          IGST: igstAmt,
          netAmount:
            (registrationType == 3 && partyType === 'CUSTOMER') ||
            (data.reverseChargeFlag == 1 && (partyType === 'CUSTOMER' || Type === 'Pos')) ||
            taxTypes.includes(data?.taxability?.value)
              ? taxAmt
              : netAmt,
          manualGSTFlag: manualGSTFlag,
        };
      } else {
        updatedTableRow[index] = {
          ...updatedTableRow[index],
          amount: 0,
          taxableAMount: 0,
          IGST: 0,
          expiredtimestamp: 0,
          netAmount: 0,
          manualGSTFlag: manualGSTFlag,
        };
      }

      return updatedTableRow;
    });
  }

  function setTableAmountsByDiscount(value, index) {
    let netAmt = 0;
    let taxAmt = 0;
    let amt = 0;
    let igstAmt = 0;
    let cessAmt=0;
    const taxTypes = partyType === 'CUSTOMER' || Type === 'Pos' ? [2, 3, 5, 4, 7, 9] : [2, 3, 5, 7, 9];

    setItems((prev) => {
      const updatedTableRow = [...prev];

      if (updatedTableRow[index].qty !== '' && updatedTableRow[index].rate !== 0) {
        amt = Number(updatedTableRow[index].qty) * Number(updatedTableRow[index].rate);

        taxAmt = Number(amt) - Number(value);
        if (updatedTableRow[index]?.manualGSTFlag === 0) {
          if (
            updatedTableRow[index]?.GSTRate !== '' &&
            Number(updatedTableRow[index]?.GSTRate) > 0 &&
            ![2, 3, 5, 7, 9].includes(data?.taxability?.value)
          ) {
            igstAmt = Number(taxAmt) * Number(updatedTableRow[index]?.GSTRate / 100);
            igstAmt = Number(igstAmt) / 2;
            igstAmt = Math.round(igstAmt * 100) / 100;
            igstAmt = igstAmt * 2;
          }
        } else {
          igstAmt = updatedTableRow[index]?.IGST;
        }
        
 if (updatedTableRow[index]?.manualCess === 0) {
          if (
            updatedTableRow[index]?.cessRate !== '' &&
            Number(updatedTableRow[index]?.cessRate) > 0 && updatedTableRow[index]?.cessType==="Percentage" &&
            ![2, 3, 5, 7, 9].includes(data?.taxability?.value)
          ) {
            cessAmt = Number(taxAmt) * Number(updatedTableRow[index]?.cessRate / 100);
            cessAmt = Number(Number(cessAmt).toFixed(2));

               
          }else{
             cessAmt = updatedTableRow[index]?.GSTCess;
          }
        } else {
          cessAmt = updatedTableRow[index]?.GSTCess;
        }
        if (registrationType === 1 && Type === 'Purchase') {
          netAmt = Number(taxAmt) + Number(igstAmt);
        } else {
          netAmt = Number(taxAmt) + Number(cessAmt) + Number(igstAmt);
        }
        if (netAmt > 999999999) {
          showWarningSnackbar('The Net Amount should be less than 100 crore');
          return prev;
        }
        updatedTableRow[index] = {
          ...updatedTableRow[index],
          dicount: value,
          manualDiscount: true,
          amount: amt,
          taxableAMount: taxAmt,
          IGST: igstAmt,
          GSTCess:cessAmt,
          netAmount:
            (registrationType === 3 && partyType === 'CUSTOMER') ||
            (data.reverseChargeFlag == 1 && (partyType === 'CUSTOMER' || Type === 'Pos')) ||
            taxTypes.includes(data?.taxability?.value)
              ? taxAmt
              : netAmt,
          manualGSTFlag: updatedTableRow[index]?.manualGSTFlag,
              manualCess: updatedTableRow[index]?.manualCess,
        };
      }

      return updatedTableRow;
    });
  }

  async function listItems(word, rowfrom, limitno) {
    let itemCodeArr = [];
    let itemNameArr = [];
    try {
      const res = await API.graphql(
        graphqlOperation(listItemMasterSearch, {
          word: word || '',
          type: '',
          rowfrom: rowfrom || 0,
          limitno: limitno || 20,
        })
      );
      if (res.data.listItemMasterSearch?.length > 0) {
        res.data.listItemMasterSearch.map((ele) => {
          if (ele.is_active === 1) {
            ele?.relateditemamountdetails.map((subele) => {
              if (ele.itemid === subele.itemid && subele?.isdefault === 1) {
                ele.effectiveFrom = subele.effectivedate == 0 ? 0 : moment(new Date(subele.effectivedate) * 1000).format('DD MMM YYYY');

                ele.effectiveTo = subele.expireddate == 0 ? 0 : moment(new Date(subele.expireddate) * 1000).format('DD MMM YYYY');
              }
            });

            if (Type === 'Sales' || Type === 'Pos') {
              if (ele.salesinvoiceflag === 1) {
                itemCodeArr.push({
                  label: ele.itemcode,
                  value: ele.itemid,
                  fromDate: ele.effectiveFrom,
                  toDate: ele.effectiveTo,
                  sales: ele?.salesinvoiceflag,
                  purchase: ele?.purchaseinvoiceflag,
                });
                itemNameArr.push({
                  label: ele.itemname,
                  value: ele.itemid,
                  fromDate: ele.effectiveFrom,
                  toDate: ele.effectiveTo,
                  sales: ele?.salesinvoiceflag,
                  purchase: ele?.purchaseinvoiceflag,
                });
              }
            }
            if (Type === 'Purchase') {
              if (ele.purchaseinvoiceflag === 1) {
                itemCodeArr.push({
                  label: ele.itemcode,
                  value: ele.itemid,
                  fromDate: ele.effectiveFrom,
                  toDate: ele.effectiveTo,
                  sales: ele?.salesinvoiceflag,
                  purchase: ele?.purchaseinvoiceflag,
                });
                itemNameArr.push({
                  label: ele.itemname,
                  value: ele.itemid,
                  fromDate: ele.effectiveFrom,
                  toDate: ele.effectiveTo,
                  sales: ele?.salesinvoiceflag,
                  purchase: ele?.purchaseinvoiceflag,
                });
              }
            }
            if (Type === 'DebitNote' || Type === 'CreditNote') {
              if (partyType === 'SUPPLIER') {
                if (ele.purchaseinvoiceflag === 1) {
                  itemCodeArr.push({
                    label: ele.itemcode,
                    value: ele.itemid,
                    fromDate: ele.effectiveFrom,
                    toDate: ele.effectiveTo,
                    sales: ele?.salesinvoiceflag,
                    purchase: ele?.purchaseinvoiceflag,
                  });
                  itemNameArr.push({
                    label: ele.itemname,
                    value: ele.itemid,
                    fromDate: ele.effectiveFrom,
                    toDate: ele.effectiveTo,
                    sales: ele?.salesinvoiceflag,
                    purchase: ele?.purchaseinvoiceflag,
                  });
                }
              } else {
                if (ele.salesinvoiceflag === 1) {
                  itemCodeArr.push({
                    label: ele.itemcode,
                    value: ele.itemid,
                    fromDate: ele.effectiveFrom,
                    toDate: ele.effectiveTo,
                    sales: ele?.salesinvoiceflag,
                    purchase: ele?.purchaseinvoiceflag,
                  });
                  itemNameArr.push({
                    label: ele.itemname,
                    value: ele.itemid,
                    fromDate: ele.effectiveFrom,
                    toDate: ele.effectiveTo,
                    sales: ele?.salesinvoiceflag,
                    purchase: ele?.purchaseinvoiceflag,
                  });
                }
              }
            }
          }
        });

        // setItemCodes(itemCodeArr);
        // setItemNames(itemNameArr);
        // setItemCodes((prev) => [
        //   ...prev,
        //   ...itemCodeArr.filter(
        //     (newItem) =>
        //       !prev.some((existingItem) => existingItem.value === newItem.value)
        //   ),
        // ]);
        setItemCodes((prev) => {
          const updatedMap = new Map(prev.map((item) => [item.value, item]));

          itemCodeArr.forEach((item) => {
            updatedMap.set(item.value, item);
          });

          return Array.from(updatedMap.values());
        });

        // setItemNames((prev) => [
        //   ...prev,
        //   ...itemNameArr.filter(
        //     (newItem) =>
        //       !prev.some((existingItem) => existingItem.value === newItem.value)
        //   ),
        // ]);
        setItemNames((prev) => {
          const updatedMap = new Map(prev.map((item) => [item.value, item]));

          itemNameArr.forEach((item) => {
            updatedMap.set(item.value, item);
          });

          return Array.from(updatedMap.values());
        });
      } else {
        setIsLoading(true);
      }
    } catch (error) {
      setBackdropOpen(false);
      console.log('error', error);
    }
  }
  async function getPriceList(Id, index) {
    try {
      // if(Id!=itemID){
      // setPriceTypeArr([]);
      setLoadingPriceType(true);
      await new Promise((resolve) => setTimeout(resolve, 0));
      let effectiveFrom = 0;
      let effectiveTo = 0;
      let priceTypeArr = [];
      let relatedAmountArr = [];
      let obj = {};
      let updatedItems = [...items];
      obj = { ...updatedItems[index] };
      const res = await API.graphql(graphqlOperation(getItemmasterAmountDetails, { itemid: Id }));

      // const sortedData =
      //   res?.data?.getItemmaster?.[0]?.relateditemamountdetails?.sort(
      //     (a, b) => {
      //       return (b.isdefault === 1) - (a.isdefault === 1);
      //     }
      //   );
      const sortedData = res?.data?.getItemmaster?.[0]?.relateditemamountdetails
        ?.filter((item) => {
          if (partyType === 'SUPPLIER') {
            return item.invoicetype == 2;
          }
          return item.invoicetype == 1;
        })
        ?.sort((a, b) => {
          return (b.isdefault === 1) - (a.isdefault === 1);
        });
      setItemID(res?.data?.getItemmaster?.[0]?.itemid);
      sortedData !== null &&
        sortedData?.map((ele) => {
          if (ele?.effectivedate !== 0) {
            effectiveFrom = ele?.effectivedate;
            effectiveTo = ele?.expireddate;
            let ShowTYempEffectiveFrom = moment(new Date(ele.effectivedate) * 1000).format('DD MMM YYYY');
            let showMomentInvoiceDate = moment(data?.invoiceDate).format('DD MMM YYYY');
            let showTempEffectiveTo = moment(new Date(ele.expireddate) * 1000).format('DD MMM YYYY');

            let tempEffectiveFrom = moment(new Date(ele.effectivedate) * 1000).format('DD MMM YYYY');
            let tempEffectiveTo = moment(new Date(ele.expireddate) * 1000).format('DD MMM YYYY');
            let momentInvoiceDate = moment(new Date(data.invoiceDate)).format('DD MMM YYYY');
            tempEffectiveFrom = moment(tempEffectiveFrom, 'DD MMM YYYY');
            tempEffectiveTo = moment(tempEffectiveTo, 'DD MMM YYYY');
            momentInvoiceDate = moment(momentInvoiceDate, 'DD MMM YYYY');
            if (!tempEffectiveTo.isValid() || ele.expireddate === 0) {
              tempEffectiveTo = moment('31 Dec 9999', 'DD MMM YYYY');
            }
            relatedAmountArr.push(ele);
            if (ele.isactive === 1) {
              // relatedAmountArr.push(ele);
              if (momentInvoiceDate.isBetween(tempEffectiveFrom, tempEffectiveTo, null, '[]')) {
                if (Type === 'Purchase') {
                  if (ele.invoicetype == 2 && ele.pricetype !== '') {
                    priceTypeArr.push({
                      label: ele.pricetype,
                      value: ele.pricetypeid,
                    });
                  }
                } else {
                  if (ele.invoicetype == 1 && ele.pricetype !== '') {
                    priceTypeArr.push({
                      label: ele.pricetype,
                      value: ele.pricetypeid,
                    });
                  }
                }
              }
            }
          }
        });
      setItems((prev) => {
        const updated = [...prev];
        updated[index] = {
          ...updated[index],
          priceTypeArr: priceTypeArr,
        };
        return updated;
      });

      // setPriceTypeArr(priceTypeArr);
      setRelatedAmounts(relatedAmountArr);
      // }
    } catch (error) {
      console.log('error', error);
    } finally {
      setLoadingPriceType(false);
    }
  }

  // async function getItems(itemID, index) {
  //   try {
  //     // let updatedTableRow = [...items];
  //     const res = await API.graphql(
  //       graphqlOperation(getItemmaster, { itemid: itemID })
  //     );

  //     let compositeRate =
  //       getCompany?.relatedcompanydetailsnew?.[0]?.comppercentage;
  //     let companyType =
  //       getCompany?.relatedcompanydetailsnew?.[0]?.registrationtype;
  //     let obj = {};
  //     let isValid = true;
  //     let gstrate =
  //       companyType == 3
  //         ? Type === "Pos" || partyType === "CUSTOMER"
  //           ? compositeRate
  //           : ""
  //         : "";
  //     let itemRate = 0;
  //     let cess = 0;
  //     let discount = 0;
  //     let wrgMsg = "";
  //     let relatedAmountArr = [];
  //     let effectiveFrom = 0;
  //     let effectiveTo = 0;
  //     let priceTypeArr = [];
  //     let priceTypeObj = { label: "", value: 0 };
  //     let isdefaultDateFrom = 0;
  //     let isdefaultDateTo = 0;

  //     if (res?.data?.getItemmaster?.[0] !== null) {
  //       setIsFocusItem(true);
  //       setRowIndex(index);

  //       if (
  //         Type === "Purchase" || partyType === "SUPPLIER"
  //           ? res?.data?.getItemmaster?.[0]?.purchaseinvoiceflag === 1
  //           : Type === "Sales" || Type === "Pos" || partyType === "CUSTOMER"
  //           ? res?.data?.getItemmaster?.[0]?.salesinvoiceflag === 1
  //           : res?.data?.getItemmaster?.[0]?.salesinvoiceflag === 1 ||
  //             res?.data?.getItemmaster?.[0]?.purchaseinvoiceflag === 1
  //       ) {
  //         // const sortedData =
  //         //   res?.data?.getItemmaster?.[0]?.relateditemamountdetails?.sort(
  //         //     (a, b) => {
  //         //       return (b.isdefault === 1) - (a.isdefault === 1);
  //         //     }
  //         //   );
  //         const sortedData = res?.data?.getItemmaster?.[0]?.relateditemamountdetails
  // ?.filter((item) => {

  //   if (partyType === "SUPPLIER") {
  //     return item.invoicetype == 2;
  //   }
  //   return item.invoicetype == 1;
  // })
  // ?.sort((a, b) => {
  //   return (b.isdefault === 1) - (a.isdefault === 1);
  // });
  //         sortedData !== null &&
  //           sortedData?.map((ele) => {
  //             if (ele?.effectivedate !== 0) {
  //               effectiveFrom = ele?.effectivedate;
  //               effectiveTo = ele?.expireddate;
  //               let ShowTYempEffectiveFrom = moment(
  //                 new Date(ele.effectivedate) * 1000
  //               ).format("DD MMM YYYY");
  //               let showMomentInvoiceDate = moment(data?.invoiceDate).format(
  //                 "DD MMM YYYY"
  //               );
  //               let showTempEffectiveTo = moment(
  //                 new Date(ele.expireddate) * 1000
  //               ).format("DD MMM YYYY");

  //               let tempEffectiveFrom = moment(
  //                 new Date(ele.effectivedate) * 1000
  //               ).format("DD MMM YYYY");
  //               let tempEffectiveTo = moment(
  //                 new Date(ele.expireddate) * 1000
  //               ).format("DD MMM YYYY");
  //               let momentInvoiceDate = moment(
  //                 new Date(data.invoiceDate)
  //               ).format("DD MMM YYYY");
  //               tempEffectiveFrom = moment(tempEffectiveFrom, "DD MMM YYYY");
  //               tempEffectiveTo = moment(tempEffectiveTo, "DD MMM YYYY");
  //               momentInvoiceDate = moment(momentInvoiceDate, "DD MMM YYYY");
  //               if (!tempEffectiveTo.isValid() || ele.expireddate === 0) {
  //                 tempEffectiveTo = moment("31 Dec 9999", "DD MMM YYYY");
  //               }
  //               relatedAmountArr.push(ele);
  //               if (ele.isactive === 1) {
  //                 if (
  //                   momentInvoiceDate.isBetween(
  //                     tempEffectiveFrom,
  //                     tempEffectiveTo,
  //                     null,
  //                     "[]"
  //                   )
  //                 ) {
  //                   if (partyType === "SUPPLIER") {
  //                     if (ele.invoicetype == 2 && ele.pricetype !== "") {
  //                       priceTypeArr.push({
  //                         label: ele.pricetype,
  //                         value: ele.pricetypeid,
  //                       });
  //                     }
  //                   } else {
  //                     if (ele.invoicetype == 1 && ele.pricetype !== "") {
  //                       priceTypeArr.push({
  //                         label: ele.pricetype,
  //                         value: ele.pricetypeid,
  //                       });
  //                     }
  //                   }
  //                 }

  //                 priceTypeArr.map((subele) => {
  //                   if (ele.pricetype !== "") {
  //                     if (
  //                       subele?.value == ele?.pricetypeid &&
  //                       ele?.isdefault == 1
  //                     ) {
  //                       priceTypeObj = {
  //                         label: subele.label,
  //                         value: subele.value,
  //                       };
  //                       isdefaultDateFrom = ele?.effectivedate;
  //                       isdefaultDateTo = ele?.expireddate;
  //                       if (registrationType !== 1) {
  //                         // gstrate =
  //                         //   companyType == 3
  //                         //     ? partyType === "CUSTOMER" || Type === "Pos"
  //                         //       ? compositeRate
  //                         //       : ""
  //                         //     : partyType === "CUSTOMER" || Type === "Pos"
  //                         //     ? ele?.gstrate
  //                         //     : "";
  //                          gstrate =
  //                           companyType == 3
  //                             ?( partyType === "CUSTOMER" || Type === "Pos"
  //                               ? compositeRate
  //                               : ele?.gstrate)
  //                             : ele?.gstrate;

  //                       } else {
  //                         gstrate = "";
  //                       }
  //                       if (Type !== "Purchase") {
  //                         discount =
  //                           ele.discounttype === 1
  //                             ? (Number(ele.amount) *
  //                                 Number(ele.discountvalue)) /
  //                               100
  //                             : ele.discountvalue;
  //                       }

  //                       itemRate = ele.amount;

  //                       if (registrationType !== 1) {
  //                         if (
  //                           data?.taxability?.value == 1 ||
  //                           data?.taxability?.value == 4 ||
  //                           data?.taxability?.value == 6 ||
  //                           data?.taxability?.value == ""
  //                         ) {
  //                           if (Type !== "Purchase") {
  //                             if (ele.gstcompensationtype == 2)
  //                               cess = ele.gstcompensationvalue;
  //                             else
  //                               cess =
  //                                 ((Number(ele.amount) - Number(discount)) *
  //                                   Number(ele.gstcompensationvalue)) /
  //                                 100;
  //                           }
  //                         }
  //                       } else {
  //                         cess = 0;
  //                       }
  //                     }
  //                   }
  //                 });
  //               }
  //             }
  //           });
  //         // setPriceTypeArr(priceTypeArr);
  //         setRelatedAmounts(relatedAmountArr);

  //         let hsnCode = {
  //           label: "",
  //           value: "",
  //           companyID: "",
  //           hsnID: "",
  //           codeType: "",
  //           description: "",
  //         };

  //         if (Number(res.data.getItemmaster?.[0]?.hsnid != 0)) {
  //           hsnCode = {
  //             label: `${res.data.getItemmaster?.[0]?.hsncodevalue} - ${res.data.getItemmaster?.[0]?.hsndescription}`,
  //             value: `${res.data.getItemmaster?.[0]?.hsncodevalue}`,
  //             companyID: res.data.getItemmaster?.[0]?.companyid,
  //             hsnID: res.data.getItemmaster?.[0]?.hsnsacid,
  //             codeType: res.data.getItemmaster?.[0]?.hsncodetype,
  //             description: res.data.getItemmaster?.[0]?.hsndescription,
  //           };
  //         }

  //         let accountobj = {
  //           label: "",
  //           value: "",
  //         };
  //         let taxObj = { label: "", value: "" };

  //         if (
  //           Type === "Sales" ||
  //           Type === "Pos" ||
  //           ((Type === "DebitNote" || Type === "CreditNote") &&
  //             partyType === "CUSTOMER")
  //         ) {
  //           ledgerList?.map((item) => {
  //             if (
  //               item?.accountsid == res.data.getItemmaster?.[0]?.salesaccountid
  //             ) {
  //               accountobj = {
  //                 label: item.accountname,
  //                 value: item.accountsid,
  //               };
  //             }
  //           });
  //         }
  //         if (
  //           Type == "Purchase" ||
  //           ((Type == "DebitNote" || Type === "CreditNote") &&
  //             partyType == "SUPPLIER")
  //         ) {
  //           ledgerList?.map((item) => {
  //             if (
  //               item?.accountsid ==
  //               res.data.getItemmaster?.[0]?.purchaseaccountid
  //             ) {
  //               accountobj = {
  //                 label: item.accountname,
  //                 value: item.accountsid,
  //               };
  //             }
  //           });
  //         }
  //         let itemNameObj = {
  //           label: "",
  //           value: "",
  //         };

  //         itemNameObj = {
  //           label: res.data.getItemmaster?.[0]?.itemname,
  //           value: res.data.getItemmaster?.[0]?.itemid,
  //         };

  //         let itemCodeObj = {
  //           label: "",
  //           value: "",
  //         };

  //         itemCodeObj = {
  //           label: res.data.getItemmaster?.[0]?.itemcode,
  //           value: res.data.getItemmaster?.[0]?.itemid,
  //         };
  //         // if (cess > 0) {
  //         // setCurrentCessValue(Number(cess));
  //         // }
  //         // setItemDiscount(discount);
  //         let igstAmt = 0;
  //         if (registrationType == 1) {
  //           cess = 0;
  //           gstrate = 0;
  //         }
  //         const taxTypes =
  //           partyType === "CUSTOMER" || Type === "Pos"
  //             ? [2, 3, 5, 4, 7, 9]
  //             : [2, 3, 5, 7, 9];
  //         // obj = { ...updatedTableRow[index] };
  //         if (isValid) {
  //           obj.itemCode = itemCodeObj;
  //           obj.priceType = priceTypeObj;
  //           obj.name = itemNameObj;
  //           obj.ledgerAccount = accountobj;
  //           obj.units = res.data.getItemmaster?.[0]?.measurementcd;
  //           obj.itemType = res.data.getItemmaster?.[0]?.itemtype;
  //           obj.HSN = hsnCode;
  //           obj.qty = 1;
  //           // if(partyType==="CUSTOMER" || Type==="Pos"){
  //           obj.GSTRate = gstrate;
  //           obj.dicount = discount;
  //           // obj.qty = 1;
  //           // if (Type !== "Purchase") {
  //             obj.rate = itemRate;
  //           // }
  //           obj.GSTCess =
  //             companyType == 1 ||
  //             (companyType == 3 &&
  //               (partyType === "CUSTOMER" || Type === "Pos")) ||
  //             [2, 3, 5, 7, 9].includes(data?.taxability?.value)
  //               ? 0
  //               : cess;
  //           obj.amount = Number(obj?.qty) * Number(obj.rate);
  //           obj.taxableAMount =
  //             Number(obj?.qty) * (Number(obj.rate) - Number(obj?.dicount));
  //           igstAmt =
  //             companyType == 1 ||
  //             [2, 3, 5, 7, 9].includes(data?.taxability?.value)
  //               ? 0
  //               : (Number(obj.taxableAMount) * Number(obj.GSTRate)) / 100;
  //           igstAmt = Number(igstAmt) / 2;
  //           igstAmt = Math.round(igstAmt * 100) / 100;
  //           igstAmt = igstAmt * 2;
  //           obj.IGST = igstAmt > 0 ? igstAmt : 0;
  //           // obj.HSN = hsnCode;
  //           obj.manualCess = false;
  //           obj.manualDiscount = false;
  //           obj.autoCess = cess;
  //           obj.effectiveFrom = isdefaultDateFrom;
  //           obj.effectiveTo = isdefaultDateTo;
  //           obj.autoDiscount = discount;
  //           obj.netAmount =
  //             Number(obj.qty) === 0 || obj.qty === "" || Number(obj.rate) === 0
  //               ? 0
  //               : //  [2, 3, 5, 7, 9].includes(data?.taxability?.value)
  //               (taxTypes.includes(data?.taxability?.value) ||( companyType === 3 && partyType==="CUSTOMER")) //LEDX-4673
  //               ? Number(obj.taxableAMount)
  //               : Number(obj.taxableAMount) +
  //                 Number(obj.GSTCess) +
  //                 Number(obj.IGST);
  //           obj.priceTypeArr=priceTypeArr;
  //             // }

  //           // updatedTableRow[index] = obj;

  //           setItemType(res?.data?.getItemmaster?.[0]?.itemtype);
  //           // setItems(updatedTableRow);
  //                 setItems((prev) => {
  //       const updated = [...prev];
  //       updated[index] = { ...updated[index], ...obj };
  //       return updated;
  //     });
  //         } else {
  //           // setPriceTypeArr([]);
  //           showWarningSnackbar(wrgMsg);

  //           isValid = true;
  //         }
  //       } else {
  //       }
  //     }
  //   } catch (error) {
  //     setBackdropOpen(false);
  //     console.log("error", error);
  //   }
  // }

  //LEDX-4724 CHange----->>
  async function getItems(itemID, index) {
    try {
      let updatedTableRow = [...items];
      const res = await API.graphql(graphqlOperation(getItemmaster, { itemid: itemID }));

      let compositeRate = getCompany?.relatedcompanydetailsnew?.[0]?.comppercentage;
      let companyType = getCompany?.relatedcompanydetailsnew?.[0]?.registrationtype;
      let obj = {};
      let isValid = true;
      let gstrate = companyType == 3 ? (Type === 'Pos' || partyType === 'CUSTOMER' ? compositeRate : '') : '';
      let itemRate = 0;
      let cess = 0;
      let discount = 0;
      let wrgMsg = '';
      let relatedAmountArr = [];
      let effectiveFrom = 0;
      let effectiveTo = 0;
      let cessType=2;
      let cessRate='';
      let priceTypeArr = [];
      let priceTypeObj = { label: '', value: 0 };
      let isdefaultDateFrom = 0;
      let isdefaultDateTo = 0;
      let discountRate='';
      let discountType='Amount';

      if (res?.data?.getItemmaster?.[0] !== null) {
        setIsFocusItem(true);
        setRowIndex(index);
        const taxability = await displayDefaultTaxability(res?.data?.getItemmaster?.[0]?.taxabilitycd);

        if (
          Type === 'Purchase' || partyType === 'SUPPLIER'
            ? res?.data?.getItemmaster?.[0]?.purchaseinvoiceflag === 1
            : Type === 'Sales' || Type === 'Pos' || partyType === 'CUSTOMER'
            ? res?.data?.getItemmaster?.[0]?.salesinvoiceflag === 1
            : res?.data?.getItemmaster?.[0]?.salesinvoiceflag === 1 || res?.data?.getItemmaster?.[0]?.purchaseinvoiceflag === 1
        ) {
          // const sortedData =
          //   res?.data?.getItemmaster?.[0]?.relateditemamountdetails?.sort(
          //     (a, b) => {
          //       return (b.isdefault === 1) - (a.isdefault === 1);
          //     }
          //   );
          const sortedData = res?.data?.getItemmaster?.[0]?.relateditemamountdetails
            ?.filter((item) => {
              if (partyType === 'SUPPLIER') {
                return item.invoicetype == 2;
              }
              return item.invoicetype == 1;
            })
            ?.sort((a, b) => {
              return (b.isdefault === 1) - (a.isdefault === 1);
            });
          sortedData !== null &&
            sortedData?.map((ele) => {
              if (ele?.effectivedate !== 0) {
                effectiveFrom = ele?.effectivedate;
                effectiveTo = ele?.expireddate;
                let ShowTYempEffectiveFrom = moment(new Date(ele.effectivedate) * 1000).format('DD MMM YYYY');
                let showMomentInvoiceDate = moment(data?.invoiceDate).format('DD MMM YYYY');
                let showTempEffectiveTo = moment(new Date(ele.expireddate) * 1000).format('DD MMM YYYY');

                let tempEffectiveFrom = moment(new Date(ele.effectivedate) * 1000).format('DD MMM YYYY');
                let tempEffectiveTo = moment(new Date(ele.expireddate) * 1000).format('DD MMM YYYY');
                let momentInvoiceDate = moment(new Date(data.invoiceDate)).format('DD MMM YYYY');
                tempEffectiveFrom = moment(tempEffectiveFrom, 'DD MMM YYYY');
                tempEffectiveTo = moment(tempEffectiveTo, 'DD MMM YYYY');
                momentInvoiceDate = moment(momentInvoiceDate, 'DD MMM YYYY');
                if (!tempEffectiveTo.isValid() || ele.expireddate === 0) {
                  tempEffectiveTo = moment('31 Dec 9999', 'DD MMM YYYY');
                }
                relatedAmountArr.push(ele);
                if (ele.isactive === 1) {
                  if (momentInvoiceDate.isBetween(tempEffectiveFrom, tempEffectiveTo, null, '[]')) {
                    if (partyType === 'SUPPLIER') {
                      if (ele.invoicetype == 2 && ele.pricetype !== '') {
                        priceTypeArr.push({
                          label: ele.pricetype,
                          value: ele.pricetypeid,
                        });
                      }
                    } else {
                      if (ele.invoicetype == 1 && ele.pricetype !== '') {
                        priceTypeArr.push({
                          label: ele.pricetype,
                          value: ele.pricetypeid,
                        });
                      }
                    }
                  }

                  priceTypeArr.map((subele) => {
                    if (ele.pricetype !== '') {
                      if (subele?.value == ele?.pricetypeid && ele?.isdefault == 1) {
                        priceTypeObj = {
                          label: subele.label,
                          value: subele.value,
                        };
                        isdefaultDateFrom = ele?.effectivedate;
                        isdefaultDateTo = ele?.expireddate;
                        if (registrationType !== 1) {
                          gstrate =
                            companyType == 3 ? (partyType === 'CUSTOMER' || Type === 'Pos' ? compositeRate : ele?.gstrate) : ele?.gstrate;
                        } else {
                          gstrate = 0;
                        }
                        // if (Type !== "Purchase") {
                        // discount =
                        //   ele.discounttype === 1
                        //     ? (Number(ele.amount) *
                        //         Number(ele.discountvalue)) /
                        //       100
                        //     : ele.discountvalue;
  //                    discount =
  // ele.discounttype === 1
  //   ? Math.round((Number(ele.amount) * Number(ele.discountvalue)) / 100 * 100) / 100
  //   : Number(ele.discountvalue);
 

if (ele.discounttype === 1) {
  discountType="Percentage";
  discountRate=ele?.discountvalue;
  discount = Math.round((Number(ele.amount) * Number(ele.discountvalue)) / 100 * 100) / 100;
} else {
  discountType="Amount";
  discountRate='';
  discount = Number(ele.discountvalue);
}

                        // }

                        itemRate = ele.amount;

                        if (registrationType !== 1) {
                          if (taxability?.value == 1 || taxability?.value == 4 || taxability?.value == 6 || taxability?.value == '') {
                            // if (Type !== "Purchase") {
                            if (ele.gstcompensationtype == 2){
                              cessRate='';
                              cessType='Amount';
                               cess = ele.gstcompensationvalue;
                            // cess =
                            //   ((Number(ele.amount) - Number(discount)) *
                            //     Number(ele.gstcompensationvalue)) /
                            //   100;
                            }
                            else{
                             cess =
 
    ((Number(ele.amount) - Number(discount)) * Number(ele.gstcompensationvalue)) /
      100 ;
      cessRate=ele.gstcompensationvalue;
      cessType='Percentage';
     cess = Number(Number(cess).toFixed(2));
                            }

    







                            // }
                          }
                        } else {
                          cess = 0;
                        }
                      }
                    }
                  });
                }
              }
            });
          // setPriceTypeArr(priceTypeArr);
          setRelatedAmounts(relatedAmountArr);

          let hsnCode = {
            label: '',
            value: '',
            companyID: '',
            hsnID: '',
            codeType: '',
            description: '',
          };

          if (Number(res.data.getItemmaster?.[0]?.hsnid != 0)) {
            hsnCode = {
              label: `${res.data.getItemmaster?.[0]?.hsncodevalue} - ${res.data.getItemmaster?.[0]?.hsndescription}`,
              value: `${res.data.getItemmaster?.[0]?.hsncodevalue}`,
              companyID: res.data.getItemmaster?.[0]?.companyid,
              hsnID: res.data.getItemmaster?.[0]?.hsnsacid,
              codeType: res.data.getItemmaster?.[0]?.hsncodetype,
              description: res.data.getItemmaster?.[0]?.hsndescription,
            };
          }

          let accountobj = {
            label: '',
            value: '',
          };
          let taxObj = { label: '', value: '' };

          if (Type === 'Sales' || Type === 'Pos' || ((Type === 'DebitNote' || Type === 'CreditNote') && partyType === 'CUSTOMER')) {
            ledgerList?.map((item) => {
              if (item?.accountsid == res.data.getItemmaster?.[0]?.salesaccountid) {
                accountobj = {
                  label: item.accountname,
                  value: item.accountsid,
                };
              }
            });
          }
          if (Type == 'Purchase' || ((Type == 'DebitNote' || Type === 'CreditNote') && partyType == 'SUPPLIER')) {
            ledgerList?.map((item) => {
              if (item?.accountsid == res.data.getItemmaster?.[0]?.purchaseaccountid) {
                accountobj = {
                  label: item.accountname,
                  value: item.accountsid,
                };
              }
            });
          }
          let itemNameObj = {
            label: '',
            value: '',
          };

          itemNameObj = {
            label: res.data.getItemmaster?.[0]?.itemname,
            value: res.data.getItemmaster?.[0]?.itemid,
          };

          let itemCodeObj = {
            label: '',
            value: '',
          };

          itemCodeObj = {
            label: res.data.getItemmaster?.[0]?.itemcode,
            value: res.data.getItemmaster?.[0]?.itemid,
          };
          // if (cess > 0) {
          // setCurrentCessValue(Number(cess));
          // }
          // setItemDiscount(discount);
          let igstAmt = 0;
          if (registrationType === 1) {
            cess = 0;
            gstrate = 0;
          }
          const taxTypes = partyType === 'CUSTOMER' || Type === 'Pos' ? [2, 3, 5, 4, 7, 9] : [2, 3, 5, 7, 9];
          // obj = { ...updatedTableRow[index] };
          if (isValid) {
            obj.itemCode = itemCodeObj;
            obj.priceType = priceTypeObj;
            obj.name = itemNameObj;
            obj.ledgerAccount = accountobj;
            obj.units = res.data.getItemmaster?.[0]?.measurementcd;
            obj.itemType = res.data.getItemmaster?.[0]?.itemtype;
            obj.HSN = hsnCode;
            obj.qty = Number(updatedTableRow[index]?.qty) ? Number(updatedTableRow[index]?.qty) : 1;
            // if(partyType==="CUSTOMER" || Type==="Pos"){
            obj.GSTRate = gstrate;
            obj.dicount = Number(obj?.qty) * Number(discount);
            // obj.qty = 1;
            // if (Type !== "Purchase") {
            obj.rate = itemRate;
            // }
            obj.GSTCess =
              companyType == 1 ||
              (companyType == 3 && (partyType === 'CUSTOMER' || Type === 'Pos')) ||
              [2, 3, 5, 7, 9].includes(taxability?.value)
                ? 0
                : Number(obj?.qty) * Number(cess);
            obj.amount = Number(obj?.qty) * Number(obj.rate);

            obj.taxableAMount = Number(obj?.qty) * Number(obj.rate) - Number(obj?.dicount);
            igstAmt =
              companyType == 1 || [2, 3, 5, 7, 9].includes(taxability?.value) ? 0 : (Number(obj.taxableAMount) * Number(obj.GSTRate)) / 100;
            igstAmt = Number(igstAmt) / 2;
            igstAmt = Math.round(igstAmt * 100) / 100;
            igstAmt = igstAmt * 2;
            obj.IGST = igstAmt > 0 ? igstAmt : 0;
            // obj.HSN = hsnCode;
            obj.manualCess = 0;
            obj.cessRate=cessRate;
            obj.cessType=cessType;
            obj.discountType=discountType;
            obj.discountRate=discountRate;

            obj.manualDiscount = false;
            obj.autoCess = Number(obj?.qty) * Number(cess);
            obj.effectiveFrom = isdefaultDateFrom;
            obj.effectiveTo = isdefaultDateTo;
            obj.autoDiscount = Number(obj?.qty) * Number(discount);
            obj.netAmount =
              Number(obj.qty) === 0 || obj.qty === '' || Number(obj.rate) === 0
                ? 0
                : //  [2, 3, 5, 7, 9].includes(taxability?.value)
                taxTypes.includes(taxability?.value) || (companyType === 3 && partyType === 'CUSTOMER') //LEDX-4673
                ? Number(obj.taxableAMount)
                : Number(obj.taxableAMount) + Number(obj.GSTCess) + Number(obj.IGST);
            obj.priceTypeArr = priceTypeArr;
            obj.manualGSTFlag = 0;
            // }

            // updatedTableRow[index] = obj;

            setItemType(res?.data?.getItemmaster?.[0]?.itemtype);
            // setItems(updatedTableRow);
            setItems((prev) => {
              const updated = [...prev];
              updated[index] = { ...updated[index], ...obj };
              return updated;
            });
          } else {
            // setPriceTypeArr([]);
            showWarningSnackbar(wrgMsg);

            isValid = true;
          }
        } else {
        }
      }
      console.log('obj', obj);
    } catch (error) {
      setBackdropOpen(false);
      console.log('error', error);
    }
  }
  //LEDX-4724 CHange----->>
  function getAmountDetailsByPriceType(priceType, index) {
    let gstrate = '';
    let itemRate = 0;
    let cess = 0;
    let discount = 0;
    let igstAmt = 0;
    let effectiveFrom = 0;
    let effectiveTo = 0;
    let cessType=1;
    let cessRate='';
     let discountRate='';
    let discountType='Amount';
    const taxTypes = partyType === 'CUSTOMER' || Type === 'Pos' ? [2, 3, 5, 4, 7, 9] : [2, 3, 5, 7, 9];

    relatedAmounts.map((ele) => {
      if (ele.pricetypeid == priceType?.value) {
        effectiveFrom = ele?.effectivedate;
        effectiveTo = ele?.expireddate;
        gstrate = registrationType === 1 ? 0 : ele.gstrate;
        // discount = ele.discounttype == 1 ? (Number(ele.amount) * Number(ele.discountvalue)) / 100 : ele.discountvalue;
        if (ele.discounttype == 1) {
  discountType="Percentage";
  discountRate=ele?.discountvalue;
  discount = Math.round((Number(ele.amount) * Number(ele.discountvalue)) / 100 * 100) / 100;
} else {
  discountType="Amount";
  discountRate='';
  discount = Number(ele.discountvalue);
}

        itemRate = ele.amount;
        if (registrationType === 1) {
          cess = 0;
        } else {
          if (ele.gstcompensationtype == 2) {
             cessType='Amount';
            cessRate='';
            cess = ele.gstcompensationvalue;
           
          } else {
            cessRate=ele.gstcompensationvalue;
            cessType='Percentage';
            cess = ((Number(ele.amount) - Number(discount)) * Number(ele.gstcompensationvalue)) / 100;
            cess = Number(Number(cess).toFixed(2));
            

          }
        }
      }
    });

    setItems((prev) => {
      const updatedTableRow = [...prev];
      let obj = { ...updatedTableRow[index] };

      obj.priceType = priceType;
      obj.GSTRate = gstrate;
      obj.dicount = Number(obj.qty) * discount;
      obj.GSTCess = companyType == 3 && (partyType === 'CUSTOMER' || Type === 'Pos') ? 0 : Number(obj.qty) * cess;
      // if (Type !== "Purchase") {
      obj.rate = itemRate;
      // }
      obj.manualCess = 0;
      obj.cessType=cessType;
      obj.cessRate=cessRate;
        obj.discountType=discountType;
            obj.discountRate=discountRate;
      obj.manualDiscount = false;
      obj.amount = Number(obj.qty) * Number(obj.rate);
      obj.autoCess = companyType == 3 && (partyType === 'CUSTOMER' || Type === 'Pos') ? 0 : cess;
      obj.autoDiscount = discount;
      obj.effectiveFrom = effectiveFrom;
      obj.effectiveTo = effectiveTo;
      obj.taxableAMount = Number(obj?.qty) * (Number(obj.rate) - Number(obj?.dicount));
      if (gstrate !== '' && Number(gstrate) > 0 && ![2, 3, 5, 7, 9].includes(data?.taxability?.value)) {
        igstAmt = (Number(obj.taxableAMount) * Number(obj.GSTRate)) / 100;
        igstAmt = Number(igstAmt) / 2;
        igstAmt = Math.round(igstAmt * 100) / 100;
        igstAmt = igstAmt * 2;
        obj.IGST = igstAmt;
      }
      obj.manualGSTFlag = 0;

      obj.netAmount =
        Number(obj.qty) === 0 || obj.qty === '' || Number(obj.rate) === 0
          ? 0
          : //LEDX-4673
          (registrationType === 3 && partyType === 'CUSTOMER') ||
            (data.reverseChargeFlag == 1 && (partyType === 'CUSTOMER' || Type === 'Pos')) ||
            taxTypes.includes(data?.taxability?.value)
          ? Number(obj.taxableAMount)
          : Number(obj.taxableAMount) + Number(obj.GSTCess) + Number(obj.IGST);

      obj.originalIGST = igstAmt * 2;
      obj.originalGSTCess = Number(obj.qty) * cess;
      obj.originalDiscount = Number(obj.qty) * discount;
      obj.originalTaxAmt = Number(obj?.qty) * (Number(obj.rate) - Number(obj?.dicount));
      obj.originalNetAmt =
        Number(obj.qty) === 0 || obj.qty === '' || Number(obj.rate) === 0
          ? 0
          : registrationType === 3 ||
            (data.reverseChargeFlag == 1 && (partyType === 'CUSTOMER' || Type === 'Pos')) ||
            taxTypes.includes(data?.taxability?.value)
          ? Number(obj.taxableAMount)
          : Number(obj.taxableAMount) + Number(obj.GSTCess) + Number(obj.IGST);

      updatedTableRow[index] = obj;
      return updatedTableRow;
    });
  }

  useEffect(() => {
    listItems('', 0, 20);
  }, [originalInvoiceNos]);
  useEffect(() => {
    if (invoiceEntry?.length !== 0 && partyType !== '') {
      // setBackdropOpen(true);
      if (Type === 'Sales' || Type === 'Pos') {
        getTableDataOfSales(invoiceEntry);
      }
      if (Type === 'Purchase') {
        getTableDataOfPurchase(invoiceEntry);
      }
      if (Type === 'DebitNote' || Type === 'CreditNote') {
        getTableDataOfCrDr(invoiceEntry);
      }
      setBackdropOpen(false);
    }
  }, [invoiceEntry, Type]);
  const textFieldRef = useRef(null);

  const scrollToField = () => {
    const element = textFieldRef.current;
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
        inline: 'center',
      });
    }
  };
  function handleTextKeyDown(e, currentId, nextId, required, warMsg, prevID) {
    if (e.key === 'Tab' && e.shiftKey) {
      e.preventDefault();
      e.stopPropagation();
      const prevElement = document.getElementById(prevID);
      prevElement?.focus();
      return;
    }

    if (e.key === 'Enter' || (e.key === 'Tab' && !e.shiftKey)) {
      if (required && (e.target.value === '' || e.target.value == 0)) {
        e.preventDefault();
        e.stopPropagation();
        showWarningSnackbar(warMsg);
        const currentElement = document.getElementById(currentId);
        currentElement?.focus();
      } else {
        e.preventDefault();
        e.stopPropagation();
        const nextElement = document.getElementById(nextId);
        nextElement?.focus();
      }
    }
  }

  function handleAutoCompleteKeyDown(e, currentId, nextId, required, warMsg, prevID, multiple) {
    const activeDescendantId = e.target.getAttribute('aria-activedescendant');
    const isAutocompleteOpen = document.activeElement.getAttribute('aria-expanded') === 'true';

    if (e.key === 'Tab' && e.shiftKey) {
      e.preventDefault();
      e.stopPropagation();
      const prevElement = document.getElementById(prevID);
      prevElement?.focus();
      return;
    }

    if ((e.key === 'Enter' || e.key === 'Tab') && !e.shiftKey) {
      if (multiple && e.key === 'Enter') {
        return; // Exit without moving focus to next field
      }

      if (
        required &&
        (e.target.value === '' || e.target.value === undefined || e.target.value === null) &&
        isAutocompleteOpen &&
        !activeDescendantId
      ) {
        e.preventDefault();
        e.stopPropagation();
        showWarningSnackbar(warMsg);
        const currentElement = document.getElementById(currentId);
        currentElement?.focus();
      } else {
        e.preventDefault();
        e.stopPropagation();
        const nextElement = document.getElementById(nextId);
        nextElement?.focus();
      }
    }
  }

  useEffect(() => {
    let updateTableRow = [...items];
    const zeroItemIndex = updateTableRow.findIndex((row) => row.itemCode?.value === '');
    if (addEvent) {
      const element = document.getElementById(`itemCode${zeroItemIndex}`);
      if (element) {
        element.focus();
      }
      setAddEvent(false);
    }
  }, [addEvent, items]);
  useEffect(() => {
    if (accountDetails) {
      if (accountDetails?.type === 'GOODS' || accountDetails?.type === 'SERVICE') {
        getItems(accountDetails?.accountsid, 0);
      }
    }
  }, [accountDetails]);

  //LEDX-4724 changes---->>
  function displayDefaultTaxability(value) {
    let taxObj = { label: '', value: '' };
    let checkTaxableOptions =
      companyType == 3 && partyType === 'CUSTOMER'
        ? compositeTaxabilityForCustomer
        : companyType == 3 && partyType === 'SUPPLIER'
        ? ['OC', 'UB'].includes(data?.partyCategory)
          ? unrSupplierTaxability
          : compositeTaxability
        : data.placeOfSupply.value === 96
        ? taxabilityOutsideIndia
        : data?.partyCategory === 'SEZ'
        ? customerTaxabilityOptions
        : data?.partyCategory === 'UB' && partyType === 'SUPPLIER'
        ? unrSupplierTaxability
        : companyType === 3
        ? compositeTaxability
        : taxabilityOptions;
    if (registrationType !== 1 && !data?.taxability?.value) {
      checkTaxableOptions.map((ele) => {
        if (Number(ele?.value) === Number(value)) {
          taxObj = { label: ele?.label, value: ele?.value };
        }
      });
      if (taxObj) {
        handleTaxabilityChange(taxObj);
        const element = document?.getElementById('taxability');
        element?.focus();
        return taxObj;
      }
    } else {
      return data?.taxability;
    }
  }
  //LEDX-4724 changes---->>

  return (
    <>
      <TableHead
        sx={{ color: '#FFF' }}
        onMouseEnter={() => {
          setIsFocusItem(true);
          setNonItemValid(true);
          setIsFocusNonItem(false);
        }}
        onMouseLeave={() => setIsFocusItem(true)}
      >
        <TableRow
          sx={{
            height: '30px',
            borderBottom: '2px solid rgba(224, 224, 224, 1)',
          }}
          className={tabelCellClass.table}
        >
          <TableCell
            colSpan={
              registrationType === 3
                ? Type === 'Sales' || Type === 'Pos'
                  ? 13 - (data?.taxability?.value !== 2 && data?.taxability?.value !== 3 && data?.taxability?.value !== 5 ? 0 : 1)
                  : partyType === 'CUSTOMER'
                  ? 14 - (data?.taxability?.value !== 2 && data?.taxability?.value !== 3 && data?.taxability?.value !== 5 ? 0 : 1)
                  : Type === 'Purchase'
                  ? 16 - (data?.taxability?.value !== 2 && data?.taxability?.value !== 3 && data?.taxability?.value !== 5 ? 0 : 1)
                  : 17 - (data?.taxability?.value !== 2 && data?.taxability?.value !== 3 && data?.taxability?.value !== 5 ? 0 : 1)
                : registrationType !== 1
                ? companyData?.relatedcompanydetailsnew?.[0]?.gstcompensationcessflag === 1
                  ? Type === 'Sales' || Type === 'Purchase' || Type === 'Pos'
                    ? 16 - (data?.taxability?.value !== 2 && data?.taxability?.value !== 3 && data?.taxability?.value !== 5 ? 0 : 3)
                    : 17 - (data?.taxability?.value !== 2 && data?.taxability?.value !== 3 && data?.taxability?.value !== 5 ? 0 : 3)
                  : Type === 'Sales' || Type === 'Pos'
                  ? 15 - (data?.taxability?.value !== 2 && data?.taxability?.value !== 3 && data?.taxability?.value !== 5 ? 0 : 2)
                  : Type === 'Sales' || Type === 'Purchase' || Type === 'Pos'
                  ? 16 - (data?.taxability?.value !== 2 && data?.taxability?.value !== 3 && data?.taxability?.value !== 5 ? 0 : 3)
                  : 17 - (data?.taxability?.value !== 2 && data?.taxability?.value !== 3 && data?.taxability?.value !== 5 ? 0 : 3)
                : Type === 'Sales' || Type === 'Purchase' || Type === 'Pos'
                ? 11
                : 12
              // - (partyType === "CUSTOMER" ? 0 : 1)
            }
          >
            {' '}
            <IconButton
              sx={{
                fontSize: '15px',
                display: 'flex',
                flexDirection: 'row',
                fontWeight: 600,
                pb: '2px',
                pt: '1px',
                color: 'primary.main',
              }}
            >
              Item-wise Entry (Quantity Wise){' '}
              {itemWiseAccordan == true ? (
                <ExpandLessIcon
                  onClick={() => {
                    if (itemWiseAccordan === true) {
                      setItemWiseAccordan(false);
                    } else {
                      setItemWiseAccordan(true);
                    }
                  }}
                />
              ) : (
                <ExpandMoreIcon
                  onClick={() => {
                    if (itemWiseAccordan == true) {
                      setItemWiseAccordan(false);
                    } else {
                      setItemWiseAccordan(true);
                    }
                  }}
                />
              )}
            </IconButton>
          </TableCell>
        </TableRow>
        <TableRow sx={{ height: '30px' }} className={tabelCellClass.table}>
          {itemWiseAccordan === true &&
            (registrationType === 3 && (Type === 'Sales' || Type === 'Pos' || partyType === 'CUSTOMER')
              ? data?.taxability?.value === 2 || data?.taxability?.value === 3 || data?.taxability?.value === 5
                ? compositetaxTypeitemWiseHeader
                : compositeItemWiseHeader
              : registrationType === 1
              ? unRegistereditemWiseHeader
              : companyData?.relatedcompanydetailsnew?.[0]?.gstcompensationcessflag === 0 && (Type === 'Sales' || Type === 'Pos')
              ? data?.taxability?.value === 2 || data?.taxability?.value === 3 || data?.taxability?.value === 5
                ? taxTypeitemWiseHeader
                : itemWiseHeaderWithoutCess
              : data?.taxability?.value === 2 || data?.taxability?.value === 3 || data?.taxability?.value === 5
              ? taxTypeitemWiseHeader
              : itemWiseHeader
            ).map((column, ind) => {
              // if (column.id === "Price Type" && partyType !== "CUSTOMER") {
              //   return null;
              // }
              if (column.id === 'HSN/SAC') {
                if (
                  // Type === "Sales" &&
                  // EInvoiceFlag &&
                  // registrationType !== 1
                  companyType === 2
                  // &&
                  // data.partyCategory !== "UB"
                ) {
                  column.required = <span style={{ color: '#e55353', paddingLeft: '2px' }}>*</span>;
                } else {
                  column.required = '';
                }
              }
              if (column.id === 'Qty' && EInvoiceFlag && itemType === 'SERVICE') {
                column.required = '';
              }
              if (column.id === 'Units' && EInvoiceFlag && itemType === 'SERVICE') {
                column.required = '';
              }
              if (column.currency !== '') {
                column.currency = data?.currency?.sign;
              }
              if (Type === 'Sales' || Type === 'Purchase' || Type === 'Pos') {
                if (column.id !== 'Reason') {
                  return (
                    <TableCell
                      key={ind}
                      align={column.align}
                      width={column.width}
                      sx={{
                        fontWeight: 600,
                        fontSize: '12px',
                        color: 'input.label',
                        backgroundColor: 'background.tablebg',
                        position: column.id === 'action' ? 'sticky' : '',
                        right: column.id === 'action' ? 0 : '',

                        zIndex: column.id === 'action' ? 1 : 0,
                      }}
                    >
                      <span>{column.label} </span>
                      {column.currency !== '' ? <span>({column.currency})</span> : ''}
                      <span>{column.required}</span>
                    </TableCell>
                  );
                }
              } else {
                return (
                  <TableCell
                    key={ind}
                    align={column.align}
                    width={column.width}
                    sx={{
                      fontWeight: 600,
                      fontSize: '12px',
                      color: 'input.label',
                      backgroundColor: 'background.tablebg',
                      position: column.id === 'action' ? 'sticky' : '',
                      right: column.id === 'action' ? 0 : '',

                      zIndex: column.id === 'action' ? 1 : 0,
                    }}
                  >
                    <span>{column.label} </span>
                    {column.currency !== '' ? <span>({column.currency})</span> : ''}
                    <span>{column.required}</span>
                  </TableCell>
                );
              }
              return null;
            })}
        </TableRow>
      </TableHead>
      {itemWiseAccordan === true && (
        <>
          <TableBody className={viewMode == true ? 'disable-interactions' : ''}>
            {items.length > 0 ? (
              items.map((col, index) => (
                <ItemRowMemo
                  key={index}
                  col={col}
                  index={index}
                  viewMode={viewMode}
                  itemCodes={itemCodes}
                  itemNames={itemNames}
                  itemValid={itemValid}
                  tabelCellClass={tabelCellClass}
                  classes={classes}
                  invoiceEntry={invoiceEntry}
                  registrationType={registrationType}
                  data={data}
                  handleItemCodeChange={handleItemCodeChange}
                  handleItemCodeInputChange={handleItemCodeInputChange}
                  handleItemCodeKeyDown={handleItemCodeKeyDown}
                  handleItemNameChange={handleItemNameChange}
                  handleItemNameInputChange={handleItemNameInputChange}
                  handleItemNameKeyDown={handleItemNameKeyDown}
                  handlePriceTypeChange={handlePriceTypeChange}
                  handlePriceTypeKeyDown={handlePriceTypeKeyDown}
                  handleReasonChange={handleReasonChange}
                  handleReasonKeyDown={handleReasonKeyDown}
                  handleGSTRateChange={handleGSTRateChange}
                  handleGSTRateKeyDown={handleGSTRateKeyDown}
                  handleHSNChange={handleHSNChange}
                  handleHSNInputChange={handleHSNInputChange}
                  handleHSNKeyDown={handleHSNKeyDown}
                  handleQuantityChange={handleQuantityChange}
                  handleQuantityKeyDown={handleQuantityKeyDown}
                  handleRateChange={handleRateChange}
                  handleRateKeyDown={handleRateKeyDown}
                  handleRateBlur={handleRateBlur}
                  handleDiscountChange={handleDiscountChange}
                  handleDiscountKeyDown={handleDiscountKeyDown}
                  handleDiscountBlur={handleDiscountBlur}
                  handleGstCessChange={handleGstCessChange}
                  handleGstCessKeyDown={handleGstCessKeyDown}
                  handleGstCessBlur={handleGstCessBlur}
                  handleGstAmtBlur={handleGstAmtBlur}
                  handleUnitsChange={handleUnitsChange}
                  handleUnitsKeyDown={handleUnitsKeyDown}
                  handleTextKeyDown={handleTextKeyDown}
                  ListboxProps={ListboxProps}
                  PaperComponent={PaperComponent}
                  setOpenItemModal={setOpenItemModal}
                  setItemID={setItemID}
                  setItemType={setItemType}
                  setItemName={setItemName}
                  setRowIndex={setRowIndex}
                  getPriceList={getPriceList}
                  Type={Type}
                  partyType={partyType}
                  companyType={companyType}
                  EInvoiceFlag={EInvoiceFlag}
                  loadingPriceType={loadingPriceType}
                  gstOrCompositeRate={gstOrCompositeRate}
                  compositeRate={compositeRate}
                  units={units}
                  unitsObj={unitsObj}
                  filterHSN={filterHSN}
                  items={items}
                  HSNListboxProps={HSNListboxProps}
                  companyData={companyData}
                  companyState={companyState}
                  textFieldRef={textFieldRef}
                  scrollToField={scrollToField}
                  ToolTipComponent={ToolTipComponent}
                  saveChangesInRows={saveChangesInRows}
                  closeChangesInRows={closeChangesInRows}
                  setDeleteEntriesModal={setDeleteEntriesModal}
                  setUpdatedTableRow={setUpdatedTableRow}
                  setOpenHsnModal={setOpenHsnModal}
                  setHSNParamsID={setHSNParamsID}
                />

                // return (
                //   <TableRow
                //   onClick={() => {
                //     if (col?.itemCode?.value) {
                //       getPriceList(col.itemCode.value);
                //     }
                //   }}

                //     className={tabelCellClass.table}
                //     hover
                //     role="checkbox"
                //     sx={{
                //       height: "0px",
                //     }}
                //     key={index}
                //   >
                //     <TableCell
                //       className={
                //         col?.invalidDate ? tabelCellClass?.errorTableCell : ""
                //       }
                //       align="left"
                //     >
                //       <Typography
                //         sx={{
                //           fontSize: "14px",
                //         }}
                //       >
                //         {index + 1}
                //       </Typography>
                //     </TableCell>
                //     <TableCell
                //       align="left"
                //       className={
                //         (col?.itemCode?.label === "" && itemValid === false) ||
                //         col?.invalidDate
                //           ? tabelCellClass.errorTableCell
                //           : ""
                //       }
                //     >
                //       <Tooltip title={col?.itemCode?.label}>
                //         <Autocomplete
                //           // ref={focuscellRef}
                //           className={classes.autocomplete}
                //           openOnFocus
                //           autoFocus
                //           disableClearable
                //           id={"itemCode" + index}
                //           name={"itemCode" + index}
                //           options={["Add Item", ...itemCodes]}
                //           disabled={
                //             data?.partyName?.label == "" || viewMode === true
                //               ? true
                //               : false
                //           }
                //           value={col?.itemCode}
                //           isOptionEqualToValue={(option, value) =>
                //             option.value === value.value
                //           }
                //           componentsProps={{
                //             popper: { style: { width: "fit-content" } },
                //           }}
                //           onChange={(e, newValue) =>
                //             handleItemCodeChange(e, newValue, index)
                //           }
                //           onInputChange={(event, newInputValue, reason) => {
                //             if (reason === "input") {
                //               handleItemCodeInputChange(event, newInputValue, index);
                //             }
                //           }}

                //           onKeyDown={(e) => handleItemCodeKeyDown(e, index)}
                //           ListboxProps={ListboxProps}
                //           PaperComponent={PaperComponent}
                //           sx={{
                //             "& .MuiOutlinedInput-root": {
                //               border: "none",
                //               outline: "none",
                //               boxShadow: "none",
                //               "&:hover": {
                //                 border: "none",
                //                 outline: "none",
                //               },
                //               "&.Mui-focused": {
                //                 border: "none",
                //                 outline: "none",
                //                 boxShadow: "none",
                //               },
                //               "& fieldset": {
                //                 border: "none !important",
                //               },
                //             },

                //             // Extra safety to remove outline from input itself
                //             "& .MuiOutlinedInput-input": {
                //               outline: "none",
                //             },

                //             // Remove global focus-visible ring
                //             "&:focus-visible": {
                //               outline: "none",
                //               boxShadow: "none",
                //             },
                //             width: registrationType === 1 ? "100%" : 140,
                //           }}
                //           size="small"
                //           renderInput={(params) => (
                //             <TextField
                //               InputLabelProps={{
                //                 shrink: true,
                //               }}
                //               {...params}
                //               InputProps={{
                //                 ...params.InputProps,
                //                 endAdornment: invoiceEntry?.length === 0 && (
                //                   <>
                //                     <LabelIcon
                //                       value={col?.itemCode?.value}
                //                       params={params.InputProps.endAdornment}
                //                       setOpen={setOpenItemModal}
                //                       setParamsID={setItemID}
                //                       editMode={true}
                //                       setItemType={setItemType}
                //                       itemType={col?.itemType}
                //                       setItemName={setItemName}
                //                       type="Accounts"
                //                     />
                //                   </>
                //                 ),
                //               }}
                //             />
                //           )}
                //           renderOption={(props, option) => (
                //             <>
                //               {option === "Add Item" ? (
                //                 <MenuItem
                //                   value={"addItem"}
                //                   onClick={(event) => {
                //                     event.stopPropagation();
                //                     event.preventDefault();
                //                     setItemID("");
                //                     setItemType("");
                //                     setItemName("");
                //                     setOpenItemModal(true);
                //                     setRowIndex(index);
                //                   }}
                //                   sx={{
                //                     display: "flex",
                //                     alignItems: "center",
                //                     position: "sticky",
                //                     // bottom: "-7.5px",
                //                     mt: "-8px !important",
                //                     top: "-8px !important",
                //                     zIndex: 1,
                //                     backgroundColor: grey[50],
                //                     "&:hover": {
                //                       backgroundColor: grey[200],
                //                     },
                //                   }}
                //                 >
                //                   <AddBox
                //                     fontSize="small"
                //                     sx={{
                //                       marginRight: "5px",
                //                       color: "primary.main",
                //                     }}
                //                   />
                //                   <ListItemText
                //                     sx={{ color: "primary.main" }}
                //                     primary={"Add Item"}
                //                   />
                //                 </MenuItem>
                //               ) : (
                //                 <MenuItem
                //                   {...props}
                //                   key={option.value}
                //                   value={option.value}
                //                 >
                //                   <ListItemText primary={option.label} />
                //                 </MenuItem>
                //               )}
                //             </>
                //           )}
                //         />
                //       </Tooltip>
                //     </TableCell>
                //     <TableCell
                //       align="left"
                //       className={
                //         (col?.name?.label === "" && itemValid === false) ||
                //         col?.invalidDate
                //           ? tabelCellClass?.errorTableCell
                //           : ""
                //       }
                //     >
                //       <Tooltip title={col?.name?.label}>
                //         <Autocomplete
                //           disableClearable
                //           className={classes.autocomplete}
                //           openOnFocus
                //           id={"itemName" + index}
                //           name={"itemName" + index}
                //           options={["Add Item", ...itemNames]}
                //           value={col?.name}
                //           isOptionEqualToValue={(option, value) =>
                //             option.value === value.value
                //           }
                //           componentsProps={{
                //             popper: { style: { width: "fit-content" } },
                //           }}
                //           disabled={
                //             data?.partyName?.label == "" || viewMode === true
                //               ? true
                //               : false
                //           }
                //           onChange={(e, newValue) =>
                //             handleItemNameChange(e, newValue, index)
                //           }
                //           onInputChange={(event, newInputValue, reason) => {
                //             if (reason === "input") {
                //               handleItemNameInputChange(event, newInputValue, index); // include `index` if needed
                //             }
                //           }}

                //           onKeyDown={(e) => handleItemNameKeyDown(e, index)}
                //           ListboxProps={ListboxProps}
                //           PaperComponent={PaperComponent}
                //           sx={{
                //             "& .MuiOutlinedInput-root": {
                //               border: "none",
                //               outline: "none",
                //               boxShadow: "none",
                //               "&:hover": {
                //                 border: "none",
                //                 outline: "none",
                //               },
                //               "&.Mui-focused": {
                //                 border: "none",
                //                 outline: "none",
                //                 boxShadow: "none",
                //               },
                //               "& fieldset": {
                //                 border: "none !important",
                //               },
                //             },

                //             // Extra safety to remove outline from input itself
                //             "& .MuiOutlinedInput-input": {
                //               outline: "none",
                //             },

                //             // Remove global focus-visible ring
                //             "&:focus-visible": {
                //               outline: "none",
                //               boxShadow: "none",
                //             },
                //             width: registrationType === 1 ? "100%" : 140,
                //           }}
                //           size="small"
                //           renderInput={(params) => (
                //             <TextField
                //               InputLabelProps={{
                //                 shrink: true,
                //               }}
                //               autoFocus={false}
                //               {...params}
                //               InputProps={{
                //                 ...params.InputProps,
                //                 endAdornment: invoiceEntry?.length === 0 && (
                //                   <>
                //                     <LabelIcon
                //                       value={col?.name?.value}
                //                       params={params.InputProps.endAdornment}
                //                       setOpen={setOpenItemModal}
                //                       setParamsID={setItemID}
                //                       setItemName={setItemName}
                //                       setItemType={setItemType}
                //                       itemType={col?.itemType}
                //                       editMode={true}
                //                       type="Accounts"
                //                     />
                //                   </>
                //                 ),
                //               }}
                //             />
                //           )}
                //           renderOption={(props, option) => (
                //             <>
                //               {option === "Add Item" ? (
                //                 <MenuItem
                //                   value={"addItem"}
                //                   onClick={(event) => {
                //                     event.stopPropagation();
                //                     event.preventDefault();
                //                     setItemID("");
                //                     setItemType("");
                //                     setItemName("");
                //                     setOpenItemModal(true);
                //                     setRowIndex(index);
                //                   }}
                //                   sx={{
                //                     display: "flex",
                //                     alignItems: "center",
                //                     position: "sticky",
                //                     // bottom: "-7.5px",
                //                     mt: "-8px !important",
                //                     top: "-8px !important",
                //                     zIndex: 1,
                //                     backgroundColor: grey[50],
                //                     "&:hover": {
                //                       backgroundColor: grey[200],
                //                     },
                //                   }}
                //                 >
                //                   <AddBox
                //                     fontSize="small"
                //                     sx={{
                //                       marginRight: "5px",
                //                       color: "primary.main",
                //                     }}
                //                   />
                //                   <ListItemText
                //                     sx={{ color: "primary.main" }}
                //                     primary={"Add Item"}
                //                   />
                //                 </MenuItem>
                //               ) : (
                //                 <MenuItem
                //                   {...props}
                //                   key={option.value}
                //                   value={option.value}
                //                 >
                //                   <ListItemText primary={option.label} />
                //                 </MenuItem>
                //               )}
                //             </>
                //           )}
                //         />
                //       </Tooltip>
                //     </TableCell>
                //     {partyType === "CUSTOMER" && (
                //       <TableCell
                //         align="left"
                //         className={
                //           col?.invalidDate ? tabelCellClass?.errorTableCell : ""
                //         }
                //       >
                //         <Autocomplete
                //           disableClearable
                //           className={classes.autocomplete}
                //           id={"priceType" + index}
                //           options={priceTypeArr}
                //           value={col?.priceType}
                //           isOptionEqualToValue={(option, value) =>
                //             option.value === value.value
                //           }
                //           componentsProps={{
                //             popper: { style: { width: "fit-content" } },
                //           }}
                //           loading={loadingPriceType}
                //           loadingText="Loading..."
                //           disabled={
                //             data?.partyName?.label == "" || viewMode === true
                //               ? true
                //               : false
                //           }
                //           onChange={(e, newValue) =>
                //             handlePriceTypeChange(e, newValue, index)
                //           }
                //           onKeyDown={(e) => handlePriceTypeKeyDown(e, index)}
                //           sx={{
                //             "& .MuiOutlinedInput-root": {
                //               border: "none",
                //               outline: "none",
                //               boxShadow: "none",
                //               "&:hover": {
                //                 border: "none",
                //                 outline: "none",
                //               },
                //               "&.Mui-focused": {
                //                 border: "none",
                //                 outline: "none",
                //                 boxShadow: "none",
                //               },
                //               "& fieldset": {
                //                 border: "none !important",
                //               },
                //             },

                //             // Extra safety to remove outline from input itself
                //             "& .MuiOutlinedInput-input": {
                //               outline: "none",
                //             },

                //             // Remove global focus-visible ring
                //             "&:focus-visible": {
                //               outline: "none",
                //               boxShadow: "none",
                //             },
                //             width: registrationType === 1 ? "100%" : 140,
                //           }}
                //           size="small"
                //           renderInput={(params) => (
                //             <TextField
                //               InputLabelProps={{
                //                 shrink: true,
                //               }}
                //               {...params}
                //               InputProps={{
                //                 ...params.InputProps,
                //               }}
                //             />
                //           )}
                //         />
                //       </TableCell>
                //     )}
                //     {(Type === "DebitNote" || Type === "CreditNote") && (
                //       <TableCell
                //         align="left"
                //         className={
                //           col?.invalidDate ? tabelCellClass?.errorTableCell : ""
                //         }
                //       >
                //         <Tooltip title={col?.reason}>
                //           <TextField
                //             size="small"
                //             id={"reason" + index}
                //             name={"reason" + index}
                //             value={col?.reason}
                //             disabled={viewMode === true ? true : false}
                //             onChange={(e) => handleReasonChange(e, index)}
                //             onKeyDown={(e) => handleReasonKeyDown(e, index)}
                //             sx={{
                //               "& .MuiOutlinedInput-root": {
                //                 border: "none",
                //                 outline: "none",
                //                 boxShadow: "none",
                //                 "&:hover": {
                //                   border: "none",
                //                   outline: "none",
                //                 },
                //                 "&.Mui-focused": {
                //                   border: "none",
                //                   outline: "none",
                //                   boxShadow: "none",
                //                 },
                //                 "& fieldset": {
                //                   border: "none !important",
                //                 },
                //               },

                //               // Extra safety to remove outline from input itself
                //               "& .MuiOutlinedInput-input": {
                //                 outline: "none",
                //               },

                //               // Remove global focus-visible ring
                //               "&:focus-visible": {
                //                 outline: "none",
                //                 boxShadow: "none",
                //               },
                //               // minWidth: 180,
                //             }}
                //             InputLabelProps={{
                //               shrink: true,
                //             }}
                //           />
                //         </Tooltip>
                //       </TableCell>
                //     )}
                //     {registrationType !== 1 && (
                //       <>
                //         {data?.taxability?.value !== 2 &&
                //           data?.taxability?.value !== 3 &&
                //           data?.taxability?.value !== 5 && (
                //             <TableCell
                //               align="left"
                //               className={
                //                 (col?.GSTRate === "" &&
                //                   itemValid === false &&
                //                   (data?.taxability?.value == 1 ||
                //                     data?.taxability?.value == 4 ||
                //                     data?.taxability?.value == 6 ||
                //                     data?.taxability?.value == 8 ||
                //                     data?.taxability?.value == 9 ||
                //                     data?.taxability?.value == 7 ||
                //                     data?.taxability?.value === "")) ||
                //                 col?.invalidDate
                //                   ? tabelCellClass?.errorTableCell
                //                   : ""
                //               }
                //             >
                //               <Autocomplete
                //                 disableClearable
                //                 id={"GSTRate" + index}
                //                 openOnFocus
                //                 autoFocus
                //                 disabled={
                //                   registrationType !== 3
                //                     ? data?.taxability?.value === 2 ||
                //                       data?.taxability?.value === 3 ||
                //                       data?.taxability?.value === 5 ||
                //                       col?.itemCode?.value === "" ||
                //                       viewMode === true
                //                       ? true
                //                       : false
                //                     : data?.taxability?.value === 2 ||
                //                       data?.taxability?.value === 3 ||
                //                       data?.taxability?.value === 5 ||
                //                       col?.itemCode?.value === "" ||
                //                       viewMode === true ||
                //                       (companyType == 3 &&
                //                         (partyType === "CUSTOMER" ||
                //                           Type === "Pos"))
                //                     ? true
                //                     : false
                //                 }
                //                 value={
                //                   (companyType == 3
                //                     ? partyType === "SUPPLIER"
                //                       ? gstOrCompositeRate
                //                       : compositeRate
                //                     : gstOrCompositeRate
                //                   )?.find((item) => item.id === col?.GSTRate) ||
                //                   null
                //                 }
                //                 options={
                //                   companyType == 3
                //                     ? partyType === "SUPPLIER"
                //                       ? gstOrCompositeRate
                //                       : compositeRate
                //                     : gstOrCompositeRate
                //                 }
                //                 isOptionEqualToValue={(option, value) =>
                //                   option.value === value.value
                //                 }
                //                 getOptionLabel={(option) => option.rate}
                //                 onChange={(event, newValue) =>
                //                   handleGSTRateChange(event, newValue, index)
                //                 }
                //                 onKeyDown={(e) =>
                //                   handleGSTRateKeyDown(e, index)
                //                 }
                //                 className={classes.autocomplete}
                //                 sx={{
                //                   "& .MuiOutlinedInput-root": {
                //                     border: "none",
                //                     outline: "none",
                //                     boxShadow: "none",
                //                     "&:hover": {
                //                       border: "none",
                //                       outline: "none",
                //                     },
                //                     "&.Mui-focused": {
                //                       border: "none",
                //                       outline: "none",
                //                       boxShadow: "none",
                //                     },
                //                     "& fieldset": {
                //                       border: "none !important",
                //                     },
                //                   },

                //                   // Extra safety to remove outline from input itself
                //                   "& .MuiOutlinedInput-input": {
                //                     outline: "none",
                //                   },

                //                   // Remove global focus-visible ring
                //                   "&:focus-visible": {
                //                     outline: "none",
                //                     boxShadow: "none",
                //                   },
                //                   width: 70,
                //                 }}
                //                 renderInput={(params) => (
                //                   <TextField
                //                     {...params}
                //                     name="GSTRate"
                //                     label=""
                //                     variant="outlined"
                //                     size="small"
                //                     fullWidth
                //                     InputLabelProps={{ shrink: true }}
                //                   />
                //                 )}
                //               />
                //             </TableCell>
                //           )}
                //         <TableCell
                //           className={
                //             col?.invalidDate ||
                //             ((col?.HSN?.value === "" ||
                //               col?.HSN?.value === undefined ||
                //               col?.HSN.value === undefined) &&
                //               EInvoiceFlag &&
                //               Type === "Sales" &&
                //               // &&
                //               // data.partyCategory !== "UB"
                //               registrationType !== 1 &&
                //               itemValid === false)
                //               ? tabelCellClass?.errorTableCell
                //               : ""
                //           }
                //           align="left"
                //         >
                //           <Tooltip title={col?.HSN?.label}>
                //             <Autocomplete
                //               disableClearable
                //               id={"hsnCode" + index}
                //               openOnFocus
                //               options={["Add HSN/SAC Code", ...filterHSN]}
                //               componentsProps={{
                //                 popper: {
                //                   style: {
                //                     maxWidth: 300,
                //                     overflow: "auto",
                //                   },
                //                 },
                //               }}
                //               disabled={
                //                 col?.name.label === "" || viewMode === true
                //                   ? true
                //                   : false
                //               }
                //               // noOptionsText={"Search"}
                //               sx={{
                //                 "& .MuiOutlinedInput-root": {
                //                   border: "none",
                //                   outline: "none",
                //                   boxShadow: "none",
                //                   "&:hover": {
                //                     border: "none",
                //                     outline: "none",
                //                   },
                //                   "&.Mui-focused": {
                //                     border: "none",
                //                     outline: "none",
                //                     boxShadow: "none",
                //                   },
                //                   "& fieldset": {
                //                     border: "none !important",
                //                   },
                //                 },

                //                 // Extra safety to remove outline from input itself
                //                 "& .MuiOutlinedInput-input": {
                //                   outline: "none",
                //                 },

                //                 // Remove global focus-visible ring
                //                 "&:focus-visible": {
                //                   outline: "none",
                //                   boxShadow: "none",
                //                 },
                //                 minWidth: 120,
                //               }}
                //               value={col?.HSN}
                //               isOptionEqualToValue={(option, value) =>
                //                 option.value === value.value
                //               }
                //               className={classes.autocomplete}
                //               onChange={(e, newValue) =>
                //                 handleHSNChange(e, newValue, index)
                //               }
                //               onKeyDown={(e) => handleHSNKeyDown(e, index)}
                //               size="small"
                //               onInputChange={(e, newValue) =>
                //                 handleHSNInputChange(e, newValue)
                //               }
                //               ListboxProps={HSNListboxProps}
                //               renderOption={(props, option) => (
                //                 <>
                //                   {option === "Add HSN/SAC Code" ? (
                //                     <MenuItem
                //                       value={"addHsn"}
                //                       onClick={(event) => {
                //                         event.stopPropagation();
                //                         event.preventDefault();
                //                         const updatedTableArr = [...items];
                //                         setUpdatedTableRow(updatedTableArr);
                //                         setRowIndex(index);
                //                         setOpenHsnModal(true);
                //                         setHSNParamsID("");
                //                       }}
                //                       sx={{
                //                         display: "flex",
                //                         alignItems: "center",
                //                         position: "sticky",
                //                         // bottom: "-7.5px",
                //                         mt: "-8px !important",
                //                         top: "-8px !important",
                //                         backgroundColor: grey[50],
                //                         "&:hover": {
                //                           backgroundColor: grey[200],
                //                         },
                //                       }}
                //                     >
                //                       <AddBox
                //                         fontSize="small"
                //                         sx={{
                //                           marginRight: "5px",
                //                           color: "primary.main",
                //                         }}
                //                       />
                //                       <ListItemText
                //                         sx={{ color: "primary.main" }}
                //                         primary={"Add HSN/SAC Code"}
                //                       />
                //                     </MenuItem>
                //                   ) : (
                //                     <li {...props}>{option.label}</li>
                //                   )}
                //                 </>
                //               )}
                //               renderInput={(params) => (
                //                 <TextField
                //                   InputLabelProps={{
                //                     shrink: true,
                //                   }}
                //                   placeholder="Search"
                //                   onClick={() => {
                //                     setItemType(col.itemType);
                //                   }}
                //                   {...params}
                //                   label=""
                //                 />
                //               )}
                //             />
                //           </Tooltip>
                //         </TableCell>
                //       </>
                //     )}
                //     <TableCell
                //       className={
                //         col?.invalidDate ? tabelCellClass?.errorTableCell : ""
                //       }
                //       align="right"
                //     >
                //       <TextField
                //         value={QuantityFormat(col?.qty)}
                //         onChange={(e) => handleQuantityChange(e, index)}
                //         // onBlur={() => handleQuantityBlur(index)}
                //         disabled={
                //           col.name?.value == "" || viewMode === true
                //             ? true
                //             : false
                //         }
                //         id={"qty" + index}
                //         label=""
                //         type="text"
                //         variant="outlined"
                //         size="small"
                //         fullWidth
                //         sx={{
                //           "& .MuiOutlinedInput-root": {
                //             border: "none",
                //             outline: "none",
                //             boxShadow: "none",
                //             "&:hover": {
                //               border: "none",
                //               outline: "none",
                //             },
                //             "&.Mui-focused": {
                //               border: "none",
                //               outline: "none",
                //               boxShadow: "none",
                //             },
                //             "& fieldset": {
                //               border: "none !important",
                //             },
                //           },

                //           // Extra safety to remove outline from input itself
                //           "& .MuiOutlinedInput-input": {
                //             outline: "none",
                //           },

                //           // Remove global focus-visible ring
                //           "&:focus-visible": {
                //             outline: "none",
                //             boxShadow: "none",
                //           },
                //           width: 100,
                //           "& input": {
                //             textAlign: "right", // 👈 this targets the input field
                //           },
                //         }}
                //         onKeyDown={(e) => handleQuantityKeyDown(e, index)}
                //       />
                //     </TableCell>

                //     <TableCell
                //       className={
                //         col?.invalidDate ? tabelCellClass?.errorTableCell : ""
                //       }
                //       align="left"
                //     >
                //       <Tooltip title={unitsObj[col?.units]}>
                //         <Autocomplete
                //           id={"units" + index}
                //           openOnFocus
                //           disableClearable
                //           value={
                //             units?.find((unit) => unit.value === col?.units) ||
                //             null
                //           }
                //           className={classes.autocomplete}
                //           componentsProps={{
                //             popper: { style: { width: "fit-content" } },
                //           }}
                //           onChange={(event, newValue) =>
                //             handleUnitsChange(event, newValue, index)
                //           }
                //           onKeyDown={(e) => handleUnitsKeyDown(e, index)}
                //           s
                //           sx={{
                //             "& .MuiOutlinedInput-root": {
                //               border: "none",
                //               outline: "none",
                //               boxShadow: "none",
                //               "&:hover": {
                //                 border: "none",
                //                 outline: "none",
                //               },
                //               "&.Mui-focused": {
                //                 border: "none",
                //                 outline: "none",
                //                 boxShadow: "none",
                //               },
                //               "& fieldset": {
                //                 border: "none !important",
                //               },
                //             },

                //             // Extra safety to remove outline from input itself
                //             "& .MuiOutlinedInput-input": {
                //               outline: "none",
                //             },

                //             // Remove global focus-visible ring
                //             "&:focus-visible": {
                //               outline: "none",
                //               boxShadow: "none",
                //             },
                //             width: registrationType === 1 ? "100%" : 140,
                //           }}
                //           isOptionEqualToValue={(option, value) =>
                //             option.value === value?.value
                //           }
                //           disabled={
                //             col?.name?.value === "" || viewMode === true
                //               ? true
                //               : false
                //           }
                //           options={units}
                //           getOptionLabel={(option) => option.option}
                //           renderInput={(params) => (
                //             <TextField
                //               {...params}
                //               label=""
                //               variant="outlined"
                //               size="small"
                //               fullWidth
                //               InputLabelProps={{ shrink: true }}
                //             />
                //           )}
                //         />
                //       </Tooltip>
                //     </TableCell>

                //     <TableCell
                //       align="right"
                //       sx={{ outline: "none" }}
                //       className={
                //         ((col?.rate === "" || col?.rate == 0) &&
                //           itemValid === false) ||
                //         col?.invalidDate
                //           ? tabelCellClass?.errorTableCell
                //           : ""
                //       }
                //     >
                //       <TextField
                //         value={NewMoneyFormatv2(col?.rate)}
                //         //onClick={moveCursorToEnd}
                //         onChange={(e) => handleRateChange(e, index)}
                //         onBlur={() => handleRateBlur(index)}
                //         onKeyDown={(e) => handleRateKeyDown(e, index)}
                //         type="text"
                //         disabled={
                //           col?.name?.value == "" || viewMode === true
                //             ? true
                //             : false
                //         }
                //         id={"rate" + index}
                //         name={"rate" + index}
                //         label=""
                //         variant="outlined"
                //         size="small"
                //         fullWidth
                //         InputProps={{
                //           inputProps: {
                //             style: {
                //               textAlign: "right",
                //               paddingRight: "0px",
                //             },
                //             min: 0,
                //           },
                //         }}
                //         sx={{
                //           outline: "none",
                //           "& .MuiOutlinedInput-root": {
                //             border: "none",
                //             outline: "none",
                //             boxShadow: "none",
                //             "&:hover": {
                //               border: "none",
                //               outline: "none",
                //             },
                //             "&.Mui-focused": {
                //               border: "none",
                //               outline: "none",
                //               boxShadow: "none",
                //             },
                //             "& fieldset": {
                //               border: "none !important",
                //             },
                //           },

                //           // Extra safety to remove outline from input itself
                //           "& .MuiOutlinedInput-input": {
                //             outline: "none",
                //           },

                //           // Remove global focus-visible ring
                //           "&:focus-visible": {
                //             outline: "none",
                //             boxShadow: "none",
                //           },
                //           minWidth: 120,
                //         }}
                //       />
                //     </TableCell>
                //     <TableCell
                //       className={
                //         col?.invalidDate ? tabelCellClass?.errorTableCell : ""
                //       }
                //       align="right"
                //     >
                //       <Typography
                //         tabIndex={0}
                //         id={"amount" + index}
                //         sx={{
                //           fontSize: "14px",
                //           minWidth: 100,
                //           outline: "none",
                //         }}
                //         onKeyDown={(e) => {
                //           const warMsg = "";

                //           const currentId = "amount" + index;
                //           const nextId = "dicount" + index;
                //           const prevID = "rate" + index;

                //           const required = false;
                //           handleTextKeyDown(
                //             e,

                //             currentId,
                //             nextId,
                //             required,
                //             warMsg,
                //             prevID
                //           );
                //         }}
                //       >
                //         {MoneyFormatv3(Number(col?.amount).toFixed(2), "en-IN")}
                //       </Typography>
                //     </TableCell>

                //     <TableCell
                //       className={
                //         col?.invalidDate ? tabelCellClass?.errorTableCell : ""
                //       }
                //       align="right"
                //     >
                //       <TextField
                //         inputRef={textFieldRef}
                //         onFocus={(e) => {
                //           scrollToField();
                //         }}
                //         value={NewMoneyFormatv2(col?.dicount)}
                //         state={col}
                //         //onClick={moveCursorToEnd}
                //         onChange={(e) => handleDiscountChange(e, index)}
                //         onBlur={() => handleDiscountBlur(index)}
                //         onKeyDown={(e) => handleDiscountKeyDown(e, index)}
                //         sx={{
                //           "& .MuiOutlinedInput-root": {
                //             border: "none",
                //             outline: "none",
                //             boxShadow: "none",
                //             "&:hover": {
                //               border: "none",
                //               outline: "none",
                //             },
                //             "&.Mui-focused": {
                //               border: "none",
                //               outline: "none",
                //               boxShadow: "none",
                //             },
                //             "& fieldset": {
                //               border: "none !important",
                //             },
                //           },

                //           // Extra safety to remove outline from input itself
                //           "& .MuiOutlinedInput-input": {
                //             outline: "none",
                //           },

                //           // Remove global focus-visible ring
                //           "&:focus-visible": {
                //             outline: "none",
                //             boxShadow: "none",
                //           },
                //           minWidth: 120,
                //         }}
                //         disabled={
                //           col?.rate === 0 || viewMode === true ? true : false
                //         }
                //         id={"dicount" + index}
                //         name={"dicount " + index}
                //         label=""
                //         type="text"
                //         variant="outlined"
                //         size="small"
                //         fullWidth
                //         InputProps={{
                //           inputProps: {
                //             style: {
                //               textAlign: "right",
                //               paddingRight: "0px",
                //             },
                //             min: 0,
                //           },
                //         }}
                //       />
                //     </TableCell>

                //     {registrationType !== 1 &&
                //       !(
                //         registrationType === 3 &&
                //         (Type === "Sales" ||
                //           Type === "Pos" ||
                //           partyType === "CUSTOMER")
                //       ) && (
                //         <>
                //           <TableCell
                //             className={
                //               col?.invalidDate
                //                 ? tabelCellClass?.errorTableCell
                //                 : ""
                //             }
                //             align="right"
                //           >
                //             <Typography
                //               tabIndex={0}
                //               id={"taxableAMount" + index}
                //               onKeyDown={(e) => {
                //                 const warMsg = "";

                //                 const currentId = "taxableAMount" + index;
                //                 const nextId = [2, 3, 5].includes(
                //                   data?.taxability?.value
                //                 )
                //                   ? "netAmount" + index
                //                   : "IGST" + index;
                //                 const prevID = "dicount" + index;

                //                 const required = false;
                //                 handleTextKeyDown(
                //                   e,

                //                   currentId,
                //                   nextId,
                //                   required,
                //                   warMsg,
                //                   prevID
                //                 );
                //               }}
                //               sx={{
                //                 fontSize: "14px",
                //                 width: 100,
                //                 outline: "none",
                //               }}
                //             >
                //               {MoneyFormatv3(
                //                 Number(col?.taxableAMount).toFixed(2),
                //                 "en-IN"
                //               )}
                //             </Typography>
                //           </TableCell>
                //           {data?.taxability?.value !== 2 &&
                //             data?.taxability?.value !== 3 &&
                //             data?.taxability?.value !== 5 && (
                //               <TableCell
                //                 className={
                //                   col?.invalidDate
                //                     ? tabelCellClass?.errorTableCell
                //                     : ""
                //                 }
                //                 align="right"
                //               >
                //                 <div
                //                   tabIndex={0}
                //                   style={{ outline: "none", minWidth: "80px" }}
                //                   id={"IGST" + index}
                //                   onKeyDown={(e) => {
                //                     const cessFlag =
                //                       companyData?.relatedcompanydetailsnew?.[0]
                //                         ?.gstcompensationcessflag;
                //                     const warMsg = "";

                //                     const currentId = "IGST" + index;
                //                     const nextId =
                //                       (cessFlag == 1 &&
                //                         (Type === "Sales" || Type === "Pos")) ||
                //                       Type === "Purchase" ||
                //                       Type === "DebitNote" ||
                //                       Type === "CreditNote"
                //                         ? "gstCess" + index
                //                         : "netAmount" + index;
                //                     const prevID = "taxableAMount" + index;

                //                     const required = false;
                //                     handleTextKeyDown(
                //                       e,

                //                       currentId,
                //                       nextId,
                //                       required,
                //                       warMsg,
                //                       prevID
                //                     );
                //                   }}
                //                 >
                //                   {Number(col?.IGST) > 0 ? (
                //                     <ToolTipComponent
                //                       title={
                //                         data.placeOfSupply.value ==
                //                         companyState ? (
                //                           // EInvoiceFlag &&
                //                           partyType === "CUSTOMER" &&
                //                           data?.partyCategory === "SEZ" ? (
                //                             <Typography
                //                               sx={{
                //                                 fontSize: "14px",
                //                                 minWidth: 80,
                //                               }}
                //                             >
                //                               <span>
                //                                 IGST :
                //                                 {MoneyFormatv3(
                //                                   col.IGST,
                //                                   "en-IN"
                //                                 )}
                //                               </span>
                //                             </Typography>
                //                           ) : (
                //                             <Typography
                //                               sx={{
                //                                 display: "flex",
                //                                 flexDirection: "column",
                //                                 minWidth: "100px",
                //                               }}
                //                             >
                //                               <span>
                //                                 CGST :{" "}
                //                                 {MoneyFormatv3(
                //                                   Math.round(
                //                                     (col.IGST / 2) * 100
                //                                   ) / 100,
                //                                   "en-IN"
                //                                 )}
                //                               </span>
                //                               <span>
                //                                 SGST :{" "}
                //                                 {MoneyFormatv3(
                //                                   Math.round(
                //                                     (col.IGST / 2) * 100
                //                                   ) / 100,
                //                                   "en-IN"
                //                                 )}
                //                               </span>
                //                             </Typography>
                //                           )
                //                         ) : (
                //                           <Typography
                //                             sx={{
                //                               fontSize: "14px",
                //                               minWidth: 80,
                //                             }}
                //                           >
                //                             <span>
                //                               IGST :
                //                               {MoneyFormatv3(col.IGST, "en-IN")}
                //                             </span>
                //                           </Typography>
                //                         )
                //                       }
                //                       tooltipContent={MoneyFormatv3(
                //                         col.IGST,
                //                         "en-IN"
                //                       )}
                //                     />
                //                   ) : (
                //                     <Typography
                //                       sx={{
                //                         fontSize: "14px",
                //                         minWidth: 80,
                //                       }}
                //                     >
                //                       <span>{MoneyFormatv3(0, "en-IN")}</span>
                //                     </Typography>
                //                   )}
                //                 </div>
                //               </TableCell>
                //             )}

                //           {((Type !== "Sales" && Type !== "Pos") ||
                //             companyData?.relatedcompanydetailsnew?.[0]
                //               ?.gstcompensationcessflag !== 0) &&
                //             data?.taxability?.value !== 2 &&
                //             data?.taxability?.value !== 3 &&
                //             data?.taxability?.value !== 5 && (
                //               <TableCell
                //                 className={
                //                   col?.invalidDate
                //                     ? tabelCellClass?.errorTableCell
                //                     : ""
                //                 }
                //                 align="right"
                //               >
                //                 <TextField
                //                   value={NewMoneyFormatv2(col?.GSTCess)}
                //                   //onClick={moveCursorToEnd}
                //                   name={"gstCess" + index}
                //                   id={"gstCess" + index}
                //                   onChange={(e) =>
                //                     handleGstCessChange(e, index)
                //                   }
                //                   onBlur={() => handleGstCessBlur(index)}
                //                   onKeyDown={(e) =>
                //                     handleGstCessKeyDown(e, index)
                //                   }
                //                   sx={{
                //                     "& .MuiOutlinedInput-root": {
                //                       border: "none",
                //                       outline: "none",
                //                       boxShadow: "none",
                //                       "&:hover": {
                //                         border: "none",
                //                         outline: "none",
                //                       },
                //                       "&.Mui-focused": {
                //                         border: "none",
                //                         outline: "none",
                //                         boxShadow: "none",
                //                       },
                //                       "& fieldset": {
                //                         border: "none !important",
                //                       },
                //                     },

                //                     // Extra safety to remove outline from input itself
                //                     "& .MuiOutlinedInput-input": {
                //                       outline: "none",
                //                     },

                //                     // Remove global focus-visible ring
                //                     "&:focus-visible": {
                //                       outline: "none",
                //                       boxShadow: "none",
                //                     },
                //                     width: 100,
                //                   }}
                //                   disabled={
                //                     registrationType !== 3
                //                       ? data?.taxability?.value === 2 ||
                //                         data?.taxability?.value === 3 ||
                //                         data?.taxability?.value === 5 ||
                //                         col?.itemCode?.value === "" ||
                //                         data?.taxability?.value === 7 ||
                //                         viewMode === true
                //                         ? true
                //                         : false
                //                       : data?.taxability?.value === 2 ||
                //                         data?.taxability?.value === 3 ||
                //                         data?.taxability?.value === 5 ||
                //                         col?.itemCode?.value === "" ||
                //                         data?.taxability?.value === 7 ||
                //                         viewMode === true
                //                       ? true
                //                       : false
                //                   }
                //                   label=""
                //                   type="text"
                //                   variant="outlined"
                //                   size="small"
                //                   fullWidth
                //                   InputProps={{
                //                     inputProps: {
                //                       style: {
                //                         textAlign: "right",
                //                         paddingRight: "0px",
                //                       },
                //                       min: 0,
                //                     },
                //                   }}
                //                 />
                //               </TableCell>
                //             )}
                //         </>
                //       )}

                //     <TableCell
                //       className={
                //         col?.invalidDate ? tabelCellClass?.errorTableCell : ""
                //       }
                //       align="right"
                //     >
                //       <Typography
                //         tabIndex={0}
                //         id={"netAmount" + index}
                //         sx={{
                //           fontSize: "14px",
                //           width: registrationType === 1 ? "100%" : 120,
                //           outline: "none",
                //         }}
                //         onKeyDown={(e) => {
                //           const cessFlag =
                //             companyData?.relatedcompanydetailsnew?.[0]
                //               ?.gstcompensationcessflag;
                //           if (e.key === "Tab" && e.shiftKey) {
                //             e.preventDefault();
                //             e.stopPropagation();
                //             const element =
                //               registrationType !== 1
                //                 ? cessFlag == 1
                //                   ? "gstCess" + index
                //                   : "IGST" + index
                //                 : "dicount" + index;
                //             document.getElementById(element)?.focus();
                //           }
                //           if (
                //             (e.key === "Tab" && !e.shiftKey) ||
                //             e.key === "Enter"
                //           ) {
                //             e.preventDefault();
                //             e.stopPropagation();
                //             setRowIndex(index);
                //             saveChangesInRows(index);
                //           }
                //         }}
                //       >
                //         {MoneyFormatv3(
                //           Number(col?.netAmount).toFixed(2),
                //           "en-IN"
                //         )}
                //       </Typography>
                //     </TableCell>

                //     <TableCell
                //       align="right"
                //       sx={{
                //         backgroundColor: "#FFF",
                //         position: "sticky",
                //         right: 0,
                //         border: col?.invalidDate
                //           ? "3px solid red !important"
                //           : "",

                //         zIndex: 1,
                //       }}
                //       className="actionBackGround"
                //     >
                //       <Box
                //         sx={{
                //           display: "flex",
                //           justifyContent: "center",
                //         }}
                //       >
                //         <>
                //           <IconButton
                //             disabled={viewMode === true ? true : false}
                //             disableRipple
                //             aria-label="delete"
                //             sx={{
                //               margin: "0px 2px",
                //               padding: "5px",
                //               backgroundColor:
                //                 // col.new === true ?
                //                 "#fbc7c78c",
                //               //  : "#83ff7b7a",
                //             }}
                //             onClick={() => {
                //               if (col?.itemCode?.label === "") {
                //                 closeChangesInRows(index);
                //               } else {
                //                 setRowIndex(index);
                //                 setDeleteEntriesModal(true);
                //               }
                //             }}
                //           >
                //             <CloseIcon
                //               sx={{
                //                 fontSize: "18px",
                //                 color: "#eb6a6a",
                //               }}
                //             />
                //           </IconButton>
                //         </>
                //       </Box>
                //     </TableCell>
                //   </TableRow>
                // );
              ))
            ) : (
              <TableRow sx={{ height: '40px' }} className={tabelCellClass.table}>
                <TableCell
                  align="center"
                  colSpan={
                    registrationType === 3
                      ? Type === 'Sales' || Type === 'Pos'
                        ? 13 - (data?.taxability?.value !== 2 && data?.taxability?.value !== 3 && data?.taxability?.value !== 5 ? 0 : 1)
                        : Type === 'CreditNote'
                        ? 14 - (data?.taxability?.value !== 2 && data?.taxability?.value !== 3 && data?.taxability?.value !== 5 ? 0 : 1)
                        : Type === 'Purchase'
                        ? 16 - (data?.taxability?.value !== 2 && data?.taxability?.value !== 3 && data?.taxability?.value !== 5 ? 0 : 1)
                        : 17 - (data?.taxability?.value !== 2 && data?.taxability?.value !== 3 && data?.taxability?.value !== 5 ? 0 : 1)
                      : registrationType !== 1
                      ? companyData?.relatedcompanydetailsnew?.[0]?.gstcompensationcessflag === 1
                        ? Type === 'Sales' || Type === 'Purchase' || Type === 'Pos'
                          ? 16 - (data?.taxability?.value !== 2 && data?.taxability?.value !== 3 && data?.taxability?.value !== 5 ? 0 : 3)
                          : 17 - (data?.taxability?.value !== 2 && data?.taxability?.value !== 3 && data?.taxability?.value !== 5 ? 0 : 3)
                        : Type === 'Sales' || Type === 'Pos'
                        ? 15 - (data?.taxability?.value !== 2 && data?.taxability?.value !== 3 && data?.taxability?.value !== 5 ? 0 : 2)
                        : Type === 'Sales' || Type === 'Purchase' || Type === 'Pos'
                        ? 16 - (data?.taxability?.value !== 2 && data?.taxability?.value !== 3 && data?.taxability?.value !== 5 ? 0 : 3)
                        : 17 - (data?.taxability?.value !== 2 && data?.taxability?.value !== 3 && data?.taxability?.value !== 5 ? 0 : 3)
                      : Type === 'Sales' || Type === 'Purchase' || Type === 'Pos'
                      ? 11
                      : 12
                    // - (partyType === "CUSTOMER" ? 0 : 1)
                  }
                >
                  No Items Found
                </TableCell>
              </TableRow>
            )}
          </TableBody>
          <TableRow className={tabelCellClass.table}>
            {viewMode !== true && (
              <TableCell
                colSpan={
                  registrationType === 3
                    ? Type === 'Sales' || Type === 'Pos'
                      ? 13 - (data?.taxability?.value !== 2 && data?.taxability?.value !== 3 && data?.taxability?.value !== 5 ? 0 : 1)
                      : partyType === 'CUSTOMER'
                      ? 14 - (data?.taxability?.value !== 2 && data?.taxability?.value !== 3 && data?.taxability?.value !== 5 ? 0 : 1)
                      : Type === 'Purchase'
                      ? 16 - (data?.taxability?.value !== 2 && data?.taxability?.value !== 3 && data?.taxability?.value !== 5 ? 0 : 1)
                      : 17 - (data?.taxability?.value !== 2 && data?.taxability?.value !== 3 && data?.taxability?.value !== 5 ? 0 : 1)
                    : registrationType !== 1
                    ? companyData?.relatedcompanydetailsnew?.[0]?.gstcompensationcessflag === 1
                      ? Type === 'Sales' || Type === 'Purchase' || Type === 'Pos'
                        ? 16 - (data?.taxability?.value !== 2 && data?.taxability?.value !== 3 && data?.taxability?.value !== 5 ? 0 : 3)
                        : 17 - (data?.taxability?.value !== 2 && data?.taxability?.value !== 3 && data?.taxability?.value !== 5 ? 0 : 3)
                      : Type === 'Sales' || Type === 'Pos'
                      ? 15 - (data?.taxability?.value !== 2 && data?.taxability?.value !== 3 && data?.taxability?.value !== 5 ? 0 : 2)
                      : Type === 'Sales' || Type === 'Purchase' || Type === 'Pos'
                      ? 16 - (data?.taxability?.value !== 2 && data?.taxability?.value !== 3 && data?.taxability?.value !== 5 ? 0 : 3)
                      : 17 - (data?.taxability?.value !== 2 && data?.taxability?.value !== 3 && data?.taxability?.value !== 5 ? 0 : 3)
                    : Type === 'Sales' || Type === 'Purchase' || Type === 'Pos'
                    ? 11
                    : 12
                  // - (partyType === "CUSTOMER" ? 0 : 1)
                }
              >
                <Button
                  className={viewMode == true ? 'disable-interactions' : ''}
                  disableElevation
                  disableRipple
                  size="small"
                  variant="text"
                  startIcon={<AddBox />}
                  sx={{
                    fontSize: '14px',
                  }}
                  // disabled={newItemRowStatus === true ? true : false}
                  onClick={() => {
                    handleResetScroll();

                    saveChangesInRows('');
                  }}
                >
                  Add New Line
                </Button>
              </TableCell>
            )}
          </TableRow>
        </>
      )}
      {openItemModal === true && (
        <AddNewItemModal
          open={openItemModal}
          setOpen={setOpenItemModal}
          modalEvent={true}
          setItemID={setItemID}
          itemID={itemID}
          itemType={itemType}
          page={Type}
          getItems={(itemID, rowIndex) => getItems(itemID, rowIndex)}
          itemName={itemName !== '' ? itemName : items[rowIndex]?.name?.label}
          invoiceDate={data.invoiceDate}
          invDate={data?.invoiceDate}
          setAccNames={setAccNames}
          rowIndex={rowIndex}
          listItems={(newValue, rowFrom, rowTo) => listItems(newValue, rowFrom, rowTo)}
        />
      )}
      {openHsnModal === true && (
        <AddHSNModal
          open={openHsnModal}
          setOpen={setOpenHsnModal}
          setData={setItems}
          data={updatetedTableRow[rowIndex]}
          searchHSNSAC={() => searchHSNDetails('', 0, 20)}
          hsnParamsID={hsnParamsID}
          setFilterHSN={setFilterHSN}
          filteredHSN={filterHSN}
          itemType={itemType}
          rowIndex={rowIndex}
          updatetedTableRow={updatetedTableRow}
          page="Invoice"
        />
      )}
    </>
  );
}

export default NewItemTable;
